
  (() => {
    const requestText = (url, { signal, timeoutMs = 20000 } = {}) => new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();
      request.open('GET', String(url), true);
      request.withCredentials = true;
      request.timeout = timeoutMs;
      request.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      request.onload = () => {
        if (request.status >= 200 && request.status < 300) resolve(request.responseText);
        else reject(new Error(`HTTP ${request.status}`));
      };
      request.onerror = () => reject(new Error('Netzwerkanfrage fehlgeschlagen'));
      request.ontimeout = () => reject(new Error('Zeitüberschreitung'));
      request.onabort = () => {
        const error = new Error('Anfrage abgebrochen');
        error.name = 'AbortError';
        reject(error);
      };
      if (signal?.aborted) request.abort();
      else {
        signal?.addEventListener('abort', () => request.abort(), { once: true });
        request.send();
      }
    });
    const normalize = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const STORAGE_CATALOG=[{"h":"anker-solix-solarbank-2-e1600-plus-lifepo4-speicher-1600wh-fur-balkonkraftwerk","n":"Anker SOLIX Solarbank 2 E1600 Plus für Balkonkraftwerk","b":"Anker","r":"balcony","c":1.6,"x":null,"pv":1200,"g":800,"o":null,"m":2,"w":10,"ip":"IP65","heat":true,"ups":false,"sm":true,"app":true,"inv":true,"va":"confirmed800","p":929,"s":"out","shop":"/products/anker-solix-solarbank-2-e1600-plus-lifepo4-speicher-1600wh-fur-balkonkraftwerk","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/Anker_SOLIX_Solarbank_2_E1600_Plus_1.webp?v=1722893124","compat":{"h":"anker-solix-bp2700-erweiterungsakku-fur-solarbank-2-3","n":5},"support":false},{"h":"anker-solix-solarbank-3-e2700-pro","n":"Anker SOLIX Solarbank 3 E2700 Pro Speicher 2,68 kWh","b":"Anker","r":"balcony","c":2.688,"x":16.128,"pv":3600,"g":1200,"gBase":800,"o":1200,"m":4,"w":10,"ip":"IP65","heat":true,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":849,"s":"stock","shop":"/products/anker-solix-solarbank-3-e2700-pro","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/Anker_Solarbank_E2700_3_pro.webp?v=1761651048","compat":{"h":"anker-solix-bp2700-erweiterungsakku-fur-solarbank-2-3","n":5},"support":false},{"h":"ecoflow-stream-ac-5000","n":"EcoFlow STREAM AC 5000","b":"EcoFlow","r":"ac","c":5.024,"x":15.072,"pv":null,"g":3000,"gBase":800,"o":3000,"m":null,"w":10,"ip":"IP65","heat":true,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":1199,"s":"preorder","shop":"/products/ecoflow-stream-ac-5000","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/EcoFlow_STREAM_AC_5000_6.webp?v=1782482118","compat":{"h":"ecoflow-stream-erweiterungsbatterie-5-kwh","n":2},"support":false},{"h":"ecoflow-stream-ac-pro-zusatzbatterie-1920-wh","n":"EcoFlow STREAM AC Pro Zusatzbatterie 1920 Wh","b":"EcoFlow","r":"ac","c":1.92,"x":11.52,"pv":null,"g":800,"o":1200,"m":null,"w":10,"ip":"IP65","heat":true,"ups":true,"sm":true,"app":true,"inv":true,"va":"confirmed800","p":549,"s":"stock","shop":"/products/ecoflow-stream-ac-pro-zusatzbatterie-1920-wh","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/ecoflow-stream-ac-pro-stromspeicher-frontansicht.webp?v=1784503254","compat":null,"support":false},{"h":"ecoflow-stream-serie-solarbatterie-stream-5000","n":"EcoFlow STREAM Serie Solarbatterie STREAM 5000","b":"EcoFlow","r":"balcony","c":5.024,"x":15.072,"pv":5000,"g":3000,"gBase":800,"o":3000,"m":4,"w":10,"ip":"IP65","heat":true,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":1299,"s":"preorder","shop":"/products/ecoflow-stream-serie-solarbatterie-stream-5000","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/EcoFlowSTREAM5000_2.webp?v=1782399381","compat":{"h":"ecoflow-stream-erweiterungsbatterie-5-kwh","n":2},"support":false},{"h":"ecoflow-stream-ultra-stromspeicher","n":"EcoFlow STREAM Ultra 2000W AllinOne Stromspeicher","b":"EcoFlow","r":"balcony","c":1.92,"x":11.52,"pv":2000,"g":800,"o":1200,"m":4,"w":10,"ip":"IP65","heat":true,"ups":true,"sm":true,"app":true,"inv":true,"va":"confirmed800","p":649,"s":"stock","shop":"/products/ecoflow-stream-ultra-stromspeicher","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/EcoFlow_STREAM_Ultra_4.webp?v=1776168109","compat":null,"support":false},{"h":"ecoflow-stream-ultra-x","n":"EcoFlow STREAM Ultra X Stromspeicher","b":"EcoFlow","r":"balcony","c":3.84,"x":23.04,"pv":2000,"g":800,"o":1200,"m":4,"w":10,"ip":"IP65","heat":true,"ups":true,"sm":true,"app":true,"inv":true,"va":"confirmed800","p":1019,"s":"stock","shop":"/products/ecoflow-stream-ultra-x","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/ecoflow-stream-ultra-x-ac-balkonkraftwerk-speicher-produktansicht.webp?v=1784522793","compat":null,"support":false},{"h":"hoymiles-hibattery-1920-hb-1920-ac-sv","n":"Hoymiles HiBattery 1920 HB-1920-AC-SV - AC Reiner Energiespeicher","b":"Hoymiles","r":"ac","c":1.92,"x":11.52,"pv":null,"g":800,"o":800,"m":null,"w":10,"ip":"IP66","heat":true,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":565,"s":"stock","shop":"/products/hoymiles-hibattery-1920-hb-1920-ac-sv","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/Hoymiles_HiBattery_1920_HB-1920-AC-SV_-_AC_Reiner_Energiespeicher_4.webp?v=1761651207","compat":null,"support":false},{"h":"die-hoymiles-hibattery-4020-ac-ac-gekoppeltes-speichersystem","n":"Hoymiles HiBattery 4020 AC – AC-gekoppelter Heimspeicher","b":"Hoymiles","r":"ac","c":4.02,"x":16.08,"pv":null,"g":800,"o":2500,"m":null,"w":10,"ip":"IP66","heat":true,"ups":true,"sm":true,"app":true,"inv":true,"va":"confirmed800","p":999,"s":"stock","shop":"/products/die-hoymiles-hibattery-4020-ac-ac-gekoppeltes-speichersystem","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/hoymiles-hibattery-4020-ac-heimspeicher-01_4b703b0b-5553-41f4-8d43-4ec234387739.jpg?v=1784323115","compat":{"h":"hoymiles-hibattery-4020-s-erweiterungsbatterie","n":3},"support":false},{"h":"hoymiles-hibattery-4020-x-mikro-speichersystem","n":"Hoymiles HiBattery 4020 X All-in-One-Mikrospeichersystem","b":"Hoymiles","r":"balcony","c":4.02,"x":16.08,"pv":4000,"g":800,"o":2500,"m":4,"w":10,"ip":"IP66","heat":true,"ups":true,"sm":true,"app":true,"inv":true,"va":"confirmed800","p":999,"s":"stock","shop":"/products/hoymiles-hibattery-4020-x-mikro-speichersystem","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/Hoymiles_HiBattery_4020_X_11.webp?v=1785929502","compat":{"h":"hoymiles-hibattery-4020-s-erweiterungsbatterie","n":3},"support":false},{"h":"hoymiles-microstorage-ms-a2-2-24-kwh-mit-ac-bidirektionale-ladung-fur-balkonkraftwerke-mit-halterung","n":"Hoymiles MicroStorage MS-A2 2,24 kWh für Balkonkraftwerke","b":"Hoymiles","r":"ac","c":2.24,"x":4.48,"pv":null,"g":800,"o":800,"m":null,"w":10,"ip":"IP65","heat":true,"ups":null,"sm":true,"app":true,"inv":true,"va":"higher","p":649,"s":"out","shop":"/products/hoymiles-microstorage-ms-a2-2-24-kwh-mit-ac-bidirektionale-ladung-fur-balkonkraftwerke-mit-halterung","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/Hoymiles_Micro_Storage_MS-A2_2.webp?v=1725023374","compat":null,"support":false},{"h":"marstek-b2500-d-2240wh-balkonkraftwerk-speicher","n":"Marstek B2500-D 2240 Wh Balkonkraftwerk Speicher","b":"Marstek","r":"balcony","c":2.24,"x":null,"pv":1600,"g":null,"o":null,"m":2,"w":10,"ip":"IP65","heat":null,"ups":null,"sm":null,"app":true,"inv":false,"va":null,"p":499,"s":"out","shop":"/products/marstek-b2500-d-2240wh-balkonkraftwerk-speicher","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/marstek-b2500-d-2240wh-balkonkraftwerk-speicher-produktansicht-01.webp?v=1784493355","compat":null,"support":false},{"h":"marstek-jupiter-c-2560wh-aio-balkonkraftwerk-speicher","n":"Marstek Jupiter C 2560 Wh AIO Balkonkraftwerk Speicher","b":"Marstek","r":"balcony","c":2.56,"x":null,"pv":2000,"g":800,"o":null,"m":4,"w":null,"ip":"IP65","heat":null,"ups":null,"sm":true,"app":true,"inv":true,"va":"confirmed800","p":749,"s":"out","shop":"/products/marstek-jupiter-c-2560wh-aio-balkonkraftwerk-speicher","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/Marstek_Jupiter_C_2560Wh_AIO_Balkonkraftwerk_Speicher.webp?v=1743345696","compat":null,"support":false},{"h":"marstek-jupiter-c-plus-2-56-kwh-speicher-fur-balkonkraftwerke","n":"Marstek JUPITER-C Plus 2,56 kWh Speicher für Balkonkraftwerke","b":"Marstek","r":"balcony","c":2.56,"x":10.24,"pv":2400,"g":800,"o":null,"m":4,"w":null,"ip":"IP65","heat":null,"ups":null,"sm":true,"app":true,"inv":true,"va":"confirmed800","p":479,"s":"out","shop":"/products/marstek-jupiter-c-plus-2-56-kwh-speicher-fur-balkonkraftwerke","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/Marstek_Jupiter_C_Plus_Batteriespeicher.webp?v=1754316657","compat":{"h":"marstek-jupiter-c-plus-2-56-kwh-erweiterungsakku-fur-balkonkraftwerke","n":3},"support":false},{"h":"marstek-venus-a-all-in-one-balkonkraftwerk-speicher","n":"Marstek VENUS A All-In-One Balkonkraftwerk Speicher","b":"Marstek","r":"balcony","c":2.12,"x":12.72,"pv":2400,"g":1500,"o":1500,"m":4,"w":10,"ip":"IP65","heat":null,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":399,"s":"stock","shop":"/products/marstek-venus-a-all-in-one-balkonkraftwerk-speicher","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/marstek-venus-a-all-in-one-balkonkraftwerk-speicher-produktansicht-01.webp?v=1784493355","compat":null,"support":false},{"h":"marstek-venus-d-all-in-one-balkonkraftwerk-speicher","n":"Marstek VENUS D All-In-One Balkonkraftwerk Speicher","b":"Marstek","r":"balcony","c":2.56,"x":15.36,"pv":4000,"g":2500,"o":2500,"m":4,"w":10,"ip":"IP65","heat":null,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":599,"s":"stock","shop":"/products/marstek-venus-d-all-in-one-balkonkraftwerk-speicher","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/Marstek_Venus_D_All-in-One_Balkonkraftwerk_mit_Speicher_14.webp?v=1762326840","compat":null,"support":false},{"h":"marstek-venus-c-2-56kwh-speicher-fur-balkonkraftwerk-ac-gekoppelt-all-in-one","n":"Marstek Venus-C 2,56 kWh AC gekoppelt All-In-One Speichersystem","b":"Marstek","r":"ac","c":2.56,"x":null,"pv":null,"g":2500,"o":2500,"m":null,"w":10,"ip":"IP65","heat":null,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":999,"s":"out","shop":"/products/marstek-venus-c-2-56kwh-speicher-fur-balkonkraftwerk-ac-gekoppelt-all-in-one","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/marstek-venus-c-2-56kwh-speicher-fur-balkonkraftwerk-ac-gekoppelt-all-in-one-produktansicht-01.jpg?v=1784493382","compat":null,"support":false},{"h":"marstek-venus-e-gen-3-0-ac-gekoppeltes-energiespeichersystem","n":"Marstek Venus-E Gen 3.0 5,12 kWh AC gekoppelt All-In-One Speichersystem","b":"Marstek","r":"ac","c":5.12,"x":15.36,"pv":null,"g":2500,"o":2500,"m":null,"w":10,"ip":"IP65","heat":null,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":1199,"s":"out","shop":"/products/marstek-venus-e-gen-3-0-ac-gekoppeltes-energiespeichersystem","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/MarstekVenusEGen3_3.webp?v=1757585978","compat":null,"support":false},{"h":"zendure-solarflow-1600-ac","n":"Zendure SolarFlow 1600 AC+ Batteriespeicher Komplettset","b":"Zendure","r":"ac","c":1.92,"x":11.52,"pv":null,"g":1600,"o":1600,"m":null,"w":10,"ip":"IP65","heat":true,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":599,"s":"stock","shop":"/products/zendure-solarflow-1600-ac","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/ZendureSolarFlow1600AC_Batteriespeicher_10.webp?v=1770898617","compat":{"h":"zendure-solarflow-ab2000x-erweiterungsbatterie-1920wh-lifepo4-add-on","n":5},"support":false},{"h":"zendure-solarflow-2400-ac-batteriespeicher","n":"Zendure SolarFlow 2400 AC Bidirektionaler Batteriespeicher Komplettset","b":"Zendure","r":"ac","c":2.88,"x":17.28,"pv":null,"g":2400,"o":2400,"m":null,"w":10,"ip":"IP65","heat":true,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":759,"s":"stock","shop":"/products/zendure-solarflow-2400-ac-batteriespeicher","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/zendure-solarflow-2400-ac-batteriespeicher-produktansicht-01.webp?v=1784493355","compat":{"h":"zendure-solarflow-ab3000x-erweiterungsbatterie-2880wh-lifepo4-add-on","n":5},"support":false},{"h":"zendure-solarflow-2400-ac-bidirektionaler-ac-batterie","n":"Zendure SolarFlow 2400 AC+ Bidirektionaler AC Batterie","b":"Zendure","r":"ac","c":2.4,"x":16.8,"pv":null,"g":2400,"o":2400,"m":null,"w":10,"ip":"IP65","heat":true,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":679,"s":"stock","shop":"/products/zendure-solarflow-2400-ac-bidirektionaler-ac-batterie","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/ZendureSolarFlow2400AC_BidirektionalerACBatterie_8.webp?v=1770886409","compat":{"h":"zendure-solarflow-ab3000l-erweiterungsbatterie-2880wh-lifepo4-add-on","n":5},"support":false},{"h":"zendure-solarflow-2400-pro-bidirektionaler-ac-speicher","n":"Zendure SolarFlow 2400 Pro Bidirektionaler AC Speicher","b":"Zendure","r":"balcony","c":2.4,"x":16.8,"pv":3000,"g":2400,"o":2400,"m":4,"w":10,"ip":"IP65","heat":true,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":829,"s":"stock","shop":"/products/zendure-solarflow-2400-pro-bidirektionaler-ac-speicher","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/Zendure_SolarFlow_2400_Pro_Bidirektionaler_AC_Speicher_12.webp?v=1770821518","compat":{"h":"zendure-solarflow-ab3000l-erweiterungsbatterie-2880wh-lifepo4-add-on","n":5},"support":false},{"h":"zendure-solarflow-3000-mix-ac-heimspeichersystem","n":"Zendure SolarFlow 3000 Mix AC+ Heimspeichersystem mit AC-Kopplung","b":"Zendure","r":"ac","c":8,"x":null,"pv":null,"g":3000,"o":3680,"m":null,"w":10,"ip":"IP65","heat":null,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":1699,"s":"stock","shop":"/products/zendure-solarflow-3000-mix-ac-heimspeichersystem","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/ZendureSolarFlow3000MixAC_2.webp?v=1779979148","compat":null,"support":false},{"h":"zendure-solarflow-4000-mix-ac-heimspeichersystem","n":"Zendure SolarFlow 4000 Mix AC+ Heimspeichersystem","b":"Zendure","r":"ac","c":8,"x":50,"pv":null,"g":4000,"o":3680,"m":null,"w":10,"ip":"IP65","heat":null,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":1999,"s":"stock","shop":"/products/zendure-solarflow-4000-mix-ac-heimspeichersystem","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/ZendureSolarFlow4000MixAC_3.webp?v=1779979498","compat":null,"support":false},{"h":"zendure-solarflow-4000-mix-pro-heimspeicher","n":"Zendure SolarFlow 4000 Mix Pro 8 kWh Hybrid-Heimspeicher","b":"Zendure","r":"inverter","c":8,"x":50,"pv":8000,"g":4000,"o":3680,"m":2,"w":10,"ip":"IP65","heat":null,"ups":true,"sm":true,"app":true,"inv":true,"va":"higher","p":2135,"s":"stock","shop":"/products/zendure-solarflow-4000-mix-pro-heimspeicher","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/zendure-solarflow-4000-mix-pro-hybrid-heimspeicher-01_f37d1ca8-96dc-4283-b98f-f98045649fb2.jpg?v=1784322975","compat":null,"support":false},{"h":"zendure-solarflow-800-mit-1x-ab2000s-batterie","n":"Zendure SolarFlow 800 mit 1x AB2000X Batterie","b":"Zendure","r":"balcony","c":1.92,"x":11.52,"pv":1200,"g":800,"o":null,"m":2,"w":null,"ip":"IP67","heat":true,"ups":null,"sm":true,"app":true,"inv":true,"va":"confirmed800","p":849,"s":"stock","shop":"/products/zendure-solarflow-800-mit-1x-ab2000s-batterie","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/SolarFlow_800_1_AB2000X_01.webp?v=1747639363","compat":{"h":"zendure-solarflow-ab2000x-erweiterungsbatterie-1920wh-lifepo4-add-on","n":5},"support":false},{"h":"zendure-solarflow-set-1920wh-hyper-2000-mit-1x-zendure-ab2000","n":"Zendure SolarFlow Hyper 2000 mit 1x Zendure AB2000X","b":"Zendure","r":"ac","c":1.92,"x":7.68,"pv":1800,"g":1200,"o":null,"m":2,"w":10,"ip":"IP65","heat":true,"ups":null,"sm":null,"app":true,"inv":true,"va":"higher","p":629,"s":"stock","shop":"/products/zendure-solarflow-set-1920wh-hyper-2000-mit-1x-zendure-ab2000","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/Zendure_Hyper2000_Mit_Batterie.jpg?v=1724604935","compat":{"h":"zendure-solarflow-ab2000x-erweiterungsbatterie-1920wh-lifepo4-add-on","n":3},"support":false},{"h":"ecoflow-stream-erweiterungsbatterie-5-kwh","n":"EcoFlow STREAM Erweiterungsbatterie 5 kWh","b":"EcoFlow","r":"expansion","c":5.024,"x":15.072,"pv":null,"g":null,"o":null,"m":null,"w":10,"ip":"IP65","heat":true,"ups":null,"sm":null,"app":true,"inv":false,"va":null,"p":999,"s":"out","shop":"/products/ecoflow-stream-erweiterungsbatterie-5-kwh","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/EcoFlow_STREAM_Batterie_5_kWh.webp?v=1782481590","compat":null,"support":true},{"h":"hoymiles-hibattery-4020-s-erweiterungsbatterie","n":"Hoymiles HiBattery 4020 S HB-4020-S 4,02 kWh Erweiterungsbatterie","b":"Hoymiles","r":"expansion","c":4.02,"x":16.08,"pv":null,"g":null,"o":null,"m":null,"w":null,"ip":"IP66","heat":null,"ups":true,"sm":true,"app":true,"inv":false,"va":null,"p":699,"s":"stock","shop":"/products/hoymiles-hibattery-4020-s-erweiterungsbatterie","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/hoymiles-hibattery-4020-s-erweiterungsbatterie-produktansicht-01_89bf538c-8228-4e87-ae89-bcbe0da91395.webp?v=1786342872","compat":null,"support":true},{"h":"marstek-jupiter-c-plus-2-56-kwh-erweiterungsakku-fur-balkonkraftwerke","n":"Marstek JUPITER-C Plus 2,56 kWh Erweiterungsakku für Balkonkraftwerke","b":"Marstek","r":"expansion","c":2.56,"x":10.24,"pv":null,"g":null,"o":null,"m":null,"w":10,"ip":null,"heat":null,"ups":null,"sm":null,"app":null,"inv":false,"va":null,"p":368,"s":"out","shop":"/products/marstek-jupiter-c-plus-2-56-kwh-erweiterungsakku-fur-balkonkraftwerke","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/Marstek_Jupiter_C_Plus_Erweiterungsakku.webp?v=1753971373","compat":null,"support":true},{"h":"zendure-solarflow-ab2000x-erweiterungsbatterie-1920wh-lifepo4-add-on","n":"Zendure SolarFlow AB2000X Erweiterungsbatterie 1920 Wh LiFePO4 Add-on","b":"Zendure","r":"expansion","c":1.92,"x":11.52,"pv":null,"g":null,"o":null,"m":null,"w":null,"ip":"IP65","heat":true,"ups":null,"sm":null,"app":true,"inv":false,"va":null,"p":399,"s":"stock","shop":"/products/zendure-solarflow-ab2000x-erweiterungsbatterie-1920wh-lifepo4-add-on","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/ZendureSolarFlowAB2000X_7.webp?v=1779089057","compat":null,"support":true},{"h":"zendure-solarflow-ab3000l-erweiterungsbatterie-2880wh-lifepo4-add-on","n":"Zendure SolarFlow AB3000L Erweiterungsbatterie 2880 Wh LiFePO4 Add-on","b":"Zendure","r":"expansion","c":2.88,"x":17.28,"pv":null,"g":null,"o":null,"m":null,"w":null,"ip":"IP65","heat":true,"ups":null,"sm":null,"app":null,"inv":false,"va":null,"p":499,"s":"stock","shop":"/products/zendure-solarflow-ab3000l-erweiterungsbatterie-2880wh-lifepo4-add-on","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/zendure-ab3000l-erweiterungsbatterie-produktansicht-01_28fba81d-477d-4627-a728-b6672796cc4b.webp?v=1786322224","compat":null,"support":true},{"h":"zendure-solarflow-ab3000x-erweiterungsbatterie-2880wh-lifepo4-add-on","n":"Zendure SolarFlow AB3000X Erweiterungsbatterie 2880 Wh LiFePO4 Add-on","b":"Zendure","r":"expansion","c":2.88,"x":17.28,"pv":null,"g":null,"o":null,"m":null,"w":null,"ip":"IP65","heat":true,"ups":null,"sm":null,"app":true,"inv":false,"va":null,"p":479,"s":"stock","shop":"/products/zendure-solarflow-ab3000x-erweiterungsbatterie-2880wh-lifepo4-add-on","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/Zendure_AB3000X_e65b79ec-92e6-4fa4-8976-78d1856588bd.webp?v=1768399990","compat":null,"support":true}];
    const STORAGE_EXTRA_CATALOG = [{"h":"anker-solix-bp2700-erweiterungsakku-fur-solarbank-2-3","n":"Anker SOLIX BP2700 Erweiterungsakku für Solarbank 2&3","b":"Anker","r":"expansion","c":2.688,"x":16.128,"pv":null,"g":null,"o":null,"m":null,"w":null,"ip":"IP65","heat":null,"ups":null,"sm":null,"app":null,"inv":false,"va":null,"p":679,"s":"stock","shop":"/products/anker-solix-bp2700-erweiterungsakku-fur-solarbank-2-3","img":"https://cdn.shopify.com/s/files/1/0611/3335/7108/files/Anker_Solix_BP2700_Erweitungsakku_01.webp?v=1774306497","compat":null,"support":true}];
    const STORAGE_PRODUCTS = STORAGE_CATALOG.concat(STORAGE_EXTRA_CATALOG);
    const STORAGE_QUESTIONS = [
      { key: 'project', title: 'Was planst du?', help: 'Die Ausgangssituation grenzt kompatible Systemarten ein.', options: [
        ['new', 'Neuinstallation', 'Ein neues Balkonkraftwerk mit Speicher aufbauen'],
        ['retrofit', 'Bestehendes System nachrüsten', 'Vorhandene Module oder Wechselrichter weiterverwenden'],
        ['acRetrofit', 'Gezielt über AC nachrüsten', 'Die vorhandene PV-Seite unverändert lassen'],
        ['open', 'Noch nicht sicher', 'Alle bestätigten Systemarten berücksichtigen']
      ]},
      { key: 'coupling', title: 'Welche Kopplung passt zu deinem Vorhaben?', help: 'Nur bestätigte AC- beziehungsweise PV/DC-Systeme werden zugeordnet.', options: [
        ['pv', 'PV/DC-gekoppelt', 'Direkt auf der Solarseite oder als integriertes Balkonsystem'],
        ['ac', 'AC-gekoppelt', 'Über das Hausnetz nachrüsten'],
        ['either', 'Beides kommt infrage', 'AC und PV/DC vergleichen'],
        ['open', 'Noch nicht sicher', 'Kopplung nicht vorab festlegen']
      ]},
      { key: 'capacity', title: 'Welche Speicherkapazität möchtest du erreichen?', help: 'Wenn möglich, wird ein bestätigter Erweiterungsakku mitgerechnet.', options: [
        [2, 'Etwa 2 kWh', 'Kompakter Abendpuffer'],
        [5, 'Etwa 5 kWh', 'Mehr Reserven für Abend und Nacht'],
        [10, 'Etwa 10 kWh', 'Höherer Haushaltsverbrauch'],
        [15, '15 kWh oder mehr', 'Großer Bedarf mit bestätigter Erweiterung']
      ]},
      { key: 'grid', title: 'Welche netzgekoppelte Ausgangsleistung ist dir wichtig?', help: '800 VA wird nur bei bestätigtem Nachweis für den exakten Gerätetyp gewertet.', options: [
        ['va800', '800 VA', 'Einfacher Steckersolar-Registrierungsweg ist wichtig'],
        [2000, 'Etwa 1,2 bis 2,5 kW', 'Mehr Leistung mit passendem Anschlussweg'],
        [3000, '3 kW oder mehr', 'Leistungsstarkes AC-System'],
        ['open', 'Nicht entscheidend', 'Netzleistung nicht zusätzlich gewichten']
      ]},
      { key: 'backup', title: 'Welche Notstromleistung brauchst du?', help: 'Notstrom wird getrennt von der netzgekoppelten Leistung bewertet.', options: [
        [0, 'Keine Notstromfunktion nötig', 'Andere Eigenschaften sind wichtiger'],
        [1200, 'Bis etwa 1,2 kW', 'Router, Licht und kleinere Geräte'],
        [2500, 'Etwa 2,5 kW', 'Ausgewählte stärkere Haushaltsgeräte'],
        [3000, '3 kW oder mehr', 'Hohe Reserve im Off-Grid-Betrieb']
      ]},
      { key: 'expand', title: 'Wie weit soll das System später wachsen?', help: 'Unbestätigte Erweiterungen werden nicht als verfügbar bewertet.', options: [
        [0, 'Keine Erweiterung geplant', 'Das Hauptgerät genügt'],
        [6, 'Bis etwa 6 kWh', 'Moderater Wachstumsspielraum'],
        [15, 'Bis etwa 15 kWh', 'Modular weiter ausbauen'],
        [30, '30 kWh oder mehr', 'Langfristig hoher Energiebedarf']
      ]},
      { key: 'budget', title: 'Welcher Preisrahmen passt für die Lösung?', help: 'Bei einer Erweiterung zählt der berechnete Paketpreis auf Basis der aktuellen Shoppreise.', options: [
        [1000, 'Bis 1.000 €', 'Preisfokussierte Auswahl'],
        [2000, '1.000 bis 2.000 €', 'Ausgewogenes Budget'],
        [3500, '2.000 bis 3.500 €', 'Mehr Kapazität und Leistung'],
        ['open', 'Flexibel', 'Funktion und Passung sind wichtiger']
      ]}
    ];
    const STORAGE_PRESETS = {
      new: { label: 'Neuinstallation' },
      retrofit: { label: 'Nachrüstung' },
      ac: { label: 'AC-gekoppelt' },
      extension: { label: 'Erweiterung' }
    };
    const solarmoduleQuantity = (value) => {
      const text = normalize(value);
      if (/\b(ohne|kein|keine|keinen)\b/.test(text) || text === '0') return 0;
      const patterns = [/(?:x|×)\s*(\d{1,2})/, /(\d{1,2})\s*(?:x|×)/, /(\d{1,2})\s*(?:solar)?module?\b/, /(\d{1,2})\s*panels?\b/, /(?:anzahl|menge)\D{0,6}(\d{1,2})/];
      for (const pattern of patterns) {
        const match = text.match(pattern);
        if (match) return Number(match[1]);
      }
      return null;
    };
    const shippingDelivery = window.MPSmartShippingDelivery;
    const resolveDelivery = (variant, country, classifications) => {
      if (!shippingDelivery) return { status: 'unavailable', mode: '' };
      return shippingDelivery.resolve({
        variant,
        classification: shippingDelivery.classificationFor(variant, classifications),
        country,
      });
    };
    const deliveryText = (variant, country, classifications) => {
      if (!shippingDelivery) return 'Lieferzeit wird im Checkout berechnet';
      return shippingDelivery.serviceName(resolveDelivery(variant, country, classifications), {
        available: Boolean(variant.available),
      });
    };
    const taxNoteText = (card) => {
      const taxSelector = document.querySelector('#mp-tax-selector');
      if (!taxSelector) return 'Preis gemäß aktueller Shop-Einstellung';
      const country = String(taxSelector.dataset.country || 'DE').toUpperCase();
      const role = taxSelector.querySelector('[data-mp-tax-role][aria-pressed="true"]')?.dataset.mpTaxRole || 'private';
      const mode = String(card.dataset.mpTaxMode || '');
      if (mode === 'de0_twin') {
        if (country === 'DE') return role === 'business' ? 'Bruttopreis inkl. 19 % MwSt.' : 'Preis mit 0 % MwSt.';
        return role === 'business'
          ? 'Voraussichtlicher Nettopreis · USt-IdNr. wird im Checkout geprüft'
          : `Voraussichtlicher Bruttopreis inkl. MwSt. in ${country} · endgültig im Checkout`;
      }
      if (mode === 'gross_inclusive_single') {
        if (country === 'DE') return 'Shopify-Preis inkl. 19 % MwSt.';
        return role === 'business'
          ? 'Voraussichtlicher Nettopreis · USt-IdNr. wird im Checkout geprüft'
          : `Shopify-Preis inkl. MwSt. in ${country} · endgültig im Checkout`;
      }
      return 'Preis gemäß aktueller Shop-Einstellung · Steuerberechnung im Checkout';
    };
    const updateTaxNote = (card) => {
      const note = card.querySelector('[data-card-price-note]');
      if (!note) return;
      const country = String(document.querySelector('#mp-tax-selector')?.dataset.country || card.closest('[data-delivery-country]')?.dataset.deliveryCountry || 'DE').toUpperCase();
      const variant = card._mpShippingVariant;
      const classifications = card._mpShippingClassifications || {};
      const quote = variant && shippingDelivery?.quote({ variant, classifications, country });
      let shippingNote = 'Versandkosten im Checkout';
      if (quote?.status === 'ok' && variant.available) {
        shippingNote = quote.amountCents === 0
          ? (quote.requiresSpedition ? 'Kostenloser Speditionsversand' : 'Kostenloser Versand')
          : 'Versand: ' + new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency: 'EUR' }).format(quote.amountCents / 100);
        if (card.dataset.mpSmallItemShipping === 'true' && country === 'DE') shippingNote += ' für 1–7 Kleinteile · ab 8 versandkostenfrei';
      }
      note.textContent = taxNoteText(card) + ' · ' + shippingNote;
      const delivery = card.querySelector('[data-card-delivery-text]');
      if (delivery && variant) delivery.textContent = deliveryText(variant, country, classifications);
    };
    const ensureTaxVariant = async (card, variant) => {
      const mode = String(variant?.taxMode || '');
      if (!mode) return true;
      if (mode !== 'de0_twin' && mode !== 'gross_inclusive_single') return false;
      const ensureVariant = window.MiniPowerTax?.ensureVariant;
      if (typeof ensureVariant !== 'function') return false;
      try {
        return await ensureVariant(card, variant.id) === true;
      } catch (error) {
        return false;
      }
    };
    const connectTaxNotes = (root, records) => {
      const refresh = () => records.forEach((record) => { if (record.card) updateTaxNote(record.card); });
      refresh();
      const taxSelector = document.querySelector('#mp-tax-selector');
      if (!taxSelector) return;
      const observer = new MutationObserver(refresh);
      observer.observe(taxSelector, { attributes: true, subtree: true, attributeFilter: ['aria-pressed', 'data-country'] });
      root._mpTaxNoteObserver = observer;
    };
    const hydrateDesktopHero = (root) => {
      const template = root.querySelector('template[data-desktop-hero]');
      if (!template) return;
      const media = window.matchMedia('(min-width: 761px)');
      const sync = () => {
        const instance = root.querySelector('[data-desktop-hero-instance]');
        if (!media.matches) {
          instance?.remove();
          return;
        }
        if (instance) return;
        const fragment = template.content.cloneNode(true);
        const element = fragment.firstElementChild;
        if (!element) return;
        element.dataset.desktopHeroInstance = '';
        template.after(fragment);
      };
      sync();
      media.addEventListener('change', sync);
      root._mpHeroMedia = media;
      root._mpHeroSync = sync;
    };
    const init = (root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      hydrateDesktopHero(root);
      const grid = root.querySelector('[data-product-grid]');
      const deferredCardTemplates = Array.from(grid.querySelectorAll(':scope > template[data-card-template]'));
      const liveCards = Array.from(grid.querySelectorAll(':scope > [data-card]'));
      const createRecord = (source, card = null, template = null, catalogPage = 0) => ({ dataset: { ...source.dataset }, card, template, initialized: false, catalogPage });
      const records = [
        ...liveCards.map((card) => createRecord(card, card)),
        ...deferredCardTemplates.map((template) => createRecord(template, null, template))
      ];
      const recordByHandle = new Map(records.map((record) => [record.dataset.handle, record]));
      let secondaryMediaObserver = null;
      let secondaryProximityEnabled = false;
      const instantiateSecondaryMedia = (card) => {
        const template = card?.querySelector('template[data-card-secondary-image]');
        const image = template?.content.querySelector('img')?.cloneNode(true);
        if (!template || !image) return;
        template.replaceWith(image);
        card.querySelector('.mp-uc-card-images')?.classList.add('has-secondary');
        card.dataset.secondaryMediaReady = 'true';
        secondaryMediaObserver?.unobserve(card);
      };
      const observeSecondaryMedia = (card) => {
        if (!secondaryProximityEnabled || !card?.isConnected || card.hidden || !card.querySelector('template[data-card-secondary-image]')) return;
        if (secondaryMediaObserver) {
          secondaryMediaObserver.observe(card);
          return;
        }
        const rect = card.getBoundingClientRect();
        if (rect.top < window.innerHeight + 320 && rect.bottom > -320) instantiateSecondaryMedia(card);
      };
      const scanSecondaryMedia = () => records.forEach((record) => observeSecondaryMedia(record.card));
      const enableSecondaryProximity = () => {
        if (secondaryProximityEnabled) return;
        secondaryProximityEnabled = true;
        if ('IntersectionObserver' in window) {
          secondaryMediaObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) instantiateSecondaryMedia(entry.target);
            });
          }, { rootMargin: '320px 0px', threshold: 0.01 });
          root._mpSecondaryMediaObserver = secondaryMediaObserver;
        } else {
          root._mpSecondaryScrollScan = scanSecondaryMedia;
          window.addEventListener('scroll', scanSecondaryMedia, { passive: true });
        }
        scanSecondaryMedia();
      };
      const instantiateSecondaryFromIntent = (event) => {
        const card = event.target.closest?.('[data-card]');
        if (card && root.contains(card)) instantiateSecondaryMedia(card);
      };
      const enableSecondaryFromKey = (event) => {
        if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) enableSecondaryProximity();
      };
      root.addEventListener('pointerover', instantiateSecondaryFromIntent);
      root.addEventListener('pointerdown', instantiateSecondaryFromIntent);
      root.addEventListener('focusin', instantiateSecondaryFromIntent);
      root.addEventListener('wheel', enableSecondaryProximity, { once: true, passive: true });
      root.addEventListener('touchmove', enableSecondaryProximity, { once: true, passive: true });
      root.addEventListener('keydown', enableSecondaryFromKey);
      root._mpSecondaryIntent = instantiateSecondaryFromIntent;
      root._mpSecondaryEnable = enableSecondaryProximity;
      root._mpSecondaryKey = enableSecondaryFromKey;
      const search = root.querySelector('[data-search]');
      const searchSubmit = root.querySelector('[data-search-submit]');
      const vendorSelect = root.querySelector('[data-vendor]');
      const typeSelect = root.querySelector('[data-product-type]');
      const coreProductSelect = root.querySelector('[data-core-product]');
      const loadMore = root.querySelector('[data-load-more]');
      const filters = root.querySelector('[data-filters]');
      const backdrop = root.querySelector('[data-filter-backdrop]');
      const activeRow = root.querySelector('[data-active-filters]');
      const catalogStatus = root.querySelector('[data-catalog-status]');
      const nativePagination = root.querySelector('[data-native-pagination]');
      const totalPages = Math.max(1, Number(root.dataset.totalPages || 1));
      const currentPage = Math.max(1, Number(root.dataset.currentPage || 1));
      const totalProducts = Math.max(records.length, Number(root.dataset.totalProducts || records.length));
      const productsPerPage = Math.max(1, Number(root.dataset.productsPerPage || records.length || 1));
      const expectedTotalPages = Math.max(1, Math.ceil(totalProducts / productsPerPage));
      const sectionId = root.dataset.sectionId;
      const catalogView = root.dataset.view || 'mp-universal';
      const collectionUrl = root.dataset.collectionUrl || window.location.pathname;
      records.forEach((record) => { record.catalogPage = currentPage; });
      const state = {search:'',status:'all',price:'all',category:'all',vendor:'all',productType:'all',coreProduct:'all',storagePreset:'all',storageLabel:'',storageHandles:null,visible:Number(root.dataset.initialProducts || 12),selected:[]};
      const initializeCard = (record) => {
        if (!record.card || record.initialized) return record.card;
        const card = record.card;
        const staticPanelSelector = card.querySelector('[data-static-panel-selector]');
        const staticPanelValue = staticPanelSelector?.querySelector('[data-panel-static-value]');
        if (staticPanelSelector && staticPanelValue) {
          const quantity = solarmoduleQuantity(staticPanelValue.dataset.panelStaticValue);
          const showStaticPanel = Number.isInteger(quantity) && quantity > 0;
          staticPanelSelector.hidden = !showStaticPanel;
          if (showStaticPanel) staticPanelValue.textContent = quantity === 1 ? '1 Modul' : `${quantity} Module`;
        }
        const variantData = card.querySelector('[data-variant-data]');
        const selector = card.querySelector('[data-panel-selector]');
        if (variantData) {
          try {
          const config = JSON.parse(variantData.textContent);
          const hasDynamicSelector = Boolean(selector);
          const panelIndex = config.panelOptionIndex == null ? -1 : Number(config.panelOptionIndex);
          const variants = Array.isArray(config.variants) ? config.variants : [];
          const classifications = config.classifications && typeof config.classifications === 'object' ? config.classifications : {};
          const deliveryCountry = String(root.dataset.deliveryCountry || 'DE').toUpperCase();
          const initialVariant = variants.find((variant) => String(variant.id) === String(config.initialVariantId)) || variants[0];
          const initialOptions = initialVariant ? [...initialVariant.options] : [];
          const buttons = selector ? [...selector.querySelectorAll('[data-panel-value]')] : [];
          const renderVariant = (variant) => {
            if (!variant) return;
            card._mpShippingVariant = variant;
            card._mpShippingClassifications = classifications;
            const shippingClass = shippingDelivery?.classificationFor(variant, classifications);
            card.dataset.mpSmallItemShipping = String(Boolean(shippingClass)
              && typeof variant.weight_grams === 'number' && variant.weight_grams >= 0 && variant.weight_grams < 80
              && Number(shippingClass.w) <= 40000 && shippingClass.s !== true
              && !['standalone_panel', 'panel_kit'].includes(shippingClass.c));
            const selectedValue = panelIndex >= 0 ? (variant.options[panelIndex] || '') : '';
            const price = card.querySelector('[data-card-price-main]');
            const compare = card.querySelector('[data-card-price-compare]');
            const availability = card.querySelector('[data-card-availability]');
            const availabilityText = availability?.querySelector('b');
            const mediaAvailability = card.querySelector('[data-card-media-availability]');
            const deliveryWrap = card.querySelector('[data-card-delivery]');
            const delivery = card.querySelector('[data-card-delivery-text]');
            const taxPrice = card.querySelector('[data-product-price]');
            const saleBadge = card.querySelector('[data-card-sale]');
            const hasCompare = Number(variant.compareAtPrice) > Number(variant.price);
            const deliveryResult = resolveDelivery(variant, deliveryCountry, classifications);
            const availabilityLabel = shippingDelivery
              ? shippingDelivery.availabilityText(deliveryResult, { available: Boolean(variant.available) })
              : (variant.available ? 'Verfügbar' : 'Derzeit nicht verfügbar');
            const deliveryNeedsAttention = deliveryResult.status !== 'ok'
              || deliveryResult.mode === 'preorder'
              || (!variant.available && deliveryResult.mode !== 'preorder');
            if (hasDynamicSelector && price) price.textContent = variant.priceText;
            if (hasDynamicSelector && compare) {
              compare.hidden = !hasCompare;
              compare.textContent = hasCompare ? variant.compareAtText : '';
            }
            if (availability) availability.classList.toggle('is-request', deliveryNeedsAttention);
            if (availabilityText) availabilityText.textContent = availabilityLabel;
            if (mediaAvailability) {
              mediaAvailability.textContent = availabilityLabel;
              mediaAvailability.classList.toggle('is-preorder', deliveryResult.mode === 'preorder');
              mediaAvailability.classList.toggle('is-sold-out', deliveryResult.mode !== 'preorder' && !variant.available);
              mediaAvailability.setAttribute('aria-label', `Produktdetails öffnen: ${availabilityLabel}`);
            }
            if (delivery) delivery.textContent = deliveryText(variant, deliveryCountry, classifications);
            if (deliveryWrap) deliveryWrap.classList.toggle('is-request', deliveryNeedsAttention);
            const variantUrl = `${card.dataset.url}?variant=${encodeURIComponent(variant.id)}`;
            card.querySelectorAll('[data-card-variant-link]').forEach((link) => { link.href = variantUrl; });
            const variantDataset = {
              price: String(variant.price),
              available: String(Boolean(variant.available)),
              sale: String(hasCompare),
              mpTaxVariantId: String(variant.id),
              mpTaxMode: String(variant.taxMode || '')
            };
            if (hasDynamicSelector) {
              Object.assign(record.dataset, variantDataset);
              Object.assign(card.dataset, variantDataset);
              if (taxPrice) taxPrice.dataset.mpTaxDefaultVariantId = String(variant.id);
              updateTaxNote(card);
              if (saleBadge) saleBadge.hidden = !hasCompare;
              buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.panelValue === selectedValue)));
              if (record.initialized) {
                document.dispatchEvent(new CustomEvent('mp:tax-content-ready', { detail: { root: card } }));
              }
            }
          };
          const selectVariant = (panelValue) => {
            const hasPanelValue = (variant) => variant.options[panelIndex] === panelValue;
            const keepsInitialOptions = (variant) => variant.options.every((value, index) => index === panelIndex || value === initialOptions[index]);
            return variants.find((variant) => variant.available && hasPanelValue(variant) && keepsInitialOptions(variant))
              || variants.find((variant) => hasPanelValue(variant) && keepsInitialOptions(variant))
              || variants.find((variant) => variant.available && hasPanelValue(variant))
              || variants.find(hasPanelValue);
          };
          buttons.forEach((button) => {
            const quantity = solarmoduleQuantity(button.dataset.panelValue);
            if (quantity !== null) button.textContent = quantity === 1 ? '1 Modul' : `${quantity} Module`;
          });
          if (hasDynamicSelector) card._mpPanelSelector = { renderVariant, selectVariant };
          renderVariant(initialVariant);
          } catch (error) {
            if (selector) selector.hidden = true;
          }
        }
        const compareButton = card.querySelector('[data-compare]');
        if (compareButton) {
          const selected = state.selected.includes(record.dataset.handle);
          compareButton.classList.toggle('is-selected', selected);
          compareButton.textContent = selected ? '✓ Ausgewählt' : '+ Vergleichen';
        }
        record.initialized = true;
        updateTaxNote(card);
        document.dispatchEvent(new CustomEvent('mp:tax-content-ready', { detail: { root: card } }));
        return card;
      };
      const ensureCard = (record) => {
        if (!record.card) {
          const source = record.template?.content.querySelector('[data-card]');
          if (!source) return null;
          record.card = source.cloneNode(true);
          record.template.remove();
          record.template = null;
        }
        return initializeCard(record);
      };
      records.filter((record) => record.card).forEach(initializeCard);
      connectTaxNotes(root, records);
      const groups = (key) => records.reduce((map, record) => map.set(record.dataset[key], (map.get(record.dataset[key]) || 0) + 1), new Map());
      const setOptions = (select, map, allLabel, selectedValue) => {
        const allOption = document.createElement('option');
        allOption.value = 'all';
        allOption.textContent = allLabel;
        const options = [...map.entries()].filter(([value]) => value).sort((a,b) => b[1] - a[1]).map(([value,count]) => {
          const option=document.createElement('option');
          option.value=value;
          option.textContent=`${value} (${count})`;
          return option;
        });
        select.replaceChildren(allOption, ...options);
        select.value = [...select.options].some((option) => option.value === selectedValue) ? selectedValue : 'all';
      };
      const refreshFacetOptions = () => {
        setOptions(vendorSelect, groups('vendor'), 'Alle Marken', state.vendor);
        setOptions(typeSelect, groups('productType'), 'Alle Produkttypen', state.productType);
        setOptions(coreProductSelect, groups('coreProduct'), 'Alle Kernprodukte', state.coreProduct);
        state.vendor = vendorSelect.value;
        state.productType = typeSelect.value;
        state.coreProduct = coreProductSelect.value;
        [vendorSelect, typeSelect, coreProductSelect].forEach((select) => {
          select.disabled = false;
          select.removeAttribute('aria-busy');
        });
      };
      const deferredMaterialHtml = new Map();
      const catalogAbortControllers = new Set();
      root._mpCatalogAbortControllers = catalogAbortControllers;
      const pageUrl = (page) => {
        const url = new URL(collectionUrl, window.location.origin);
        const current = new URL(window.location.href);
        current.searchParams.forEach((value, key) => {
          if (!['page', 'section_id', 'sections', '_'].includes(key)) url.searchParams.append(key, value);
        });
        url.searchParams.set('view', catalogView);
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', sectionId);
        return url;
      };
      const fetchCatalogPage = async (page) => {
        const controller = new AbortController();
        catalogAbortControllers.add(controller);
        let responseText;
        try {
          responseText = await requestText(pageUrl(page), {
            signal: controller.signal,
          });
        } catch (error) {
          if (error?.name === 'AbortError') throw new Error(`Katalogseite ${page}: Zeitüberschreitung`);
          throw error;
        } finally {
          catalogAbortControllers.delete(controller);
        }
        const documentPage = new DOMParser().parseFromString(responseText, 'text/html');
        const remoteRoot = documentPage.querySelector('[data-mp-universal-collection]');
        const remoteGrid = remoteRoot?.querySelector('[data-product-grid]');
        const remoteView = remoteRoot?.dataset.view || '';
        const remoteSectionId = remoteRoot?.dataset.sectionId || '';
        if (!remoteRoot || !remoteGrid) throw new Error(`Katalogseite ${page}: Abschnitt fehlt`);
        const remotePage = Number(remoteRoot.dataset.currentPage || 0);
        const remotePages = Number(remoteRoot.dataset.totalPages || 0);
        const remoteTotal = Number(remoteRoot.dataset.totalProducts || -1);
        const remoteProductsPerPage = Number(remoteRoot.dataset.productsPerPage || 0);
        if (remoteView !== catalogView) throw new Error(`Katalogseite ${page}: Ansicht ${remoteView || '?'} statt ${catalogView}`);
        if (remoteSectionId !== sectionId) throw new Error(`Katalogseite ${page}: Abschnitt ${remoteSectionId || '?'} statt ${sectionId}`);
        if (remotePage !== page) throw new Error(`Katalogseite ${page}: Server lieferte Seite ${remotePage || '?'}`);
        if (remotePages !== totalPages || remoteTotal !== totalProducts || remoteProductsPerPage !== productsPerPage) {
          throw new Error(`Katalogseite ${page}: Katalogumfang hat sich geändert`);
        }
        const cards = Array.from(remoteGrid.querySelectorAll(':scope > [data-card]'), (card) => {
          const clone = card.cloneNode(true);
          clone.querySelectorAll('img').forEach((image) => {
            image.setAttribute('loading', 'lazy');
            image.removeAttribute('fetchpriority');
          });
          return clone;
        });
        const templates = Array.from(remoteGrid.querySelectorAll(':scope > template[data-card-template]'), (template) => template.cloneNode(true));
        const sources = [...cards, ...templates];
        const handles = sources.map((source) => source.dataset.handle).filter(Boolean);
        const expectedItems = page < totalPages
          ? productsPerPage
          : Math.max(0, totalProducts - (productsPerPage * (totalPages - 1)));
        if (sources.length !== expectedItems) {
          throw new Error(`Katalogseite ${page}: ${sources.length} statt ${expectedItems} Produkte`);
        }
        if (handles.length !== sources.length || new Set(handles).size !== handles.length) {
          throw new Error(`Katalogseite ${page}: fehlende oder doppelte Produktkennung`);
        }
        return {
          page,
          cards,
          templates,
          materialTemplates: Array.from(remoteRoot.querySelectorAll('template[data-material-template]'), (template) => [template.dataset.materialTemplate, template.innerHTML]),
        };
      };
      const ingestPage = (pageData) => {
        const incoming = [...pageData.cards, ...pageData.templates];
        const duplicate = incoming.find((source) => recordByHandle.has(source.dataset.handle));
        if (duplicate) throw new Error(`Katalogseite ${pageData.page}: Produkt ${duplicate.dataset.handle} wurde doppelt geliefert`);
        pageData.cards.forEach((card) => {
          const record = createRecord(card, card, null, pageData.page);
          records.push(record);
          recordByHandle.set(record.dataset.handle, record);
        });
        pageData.templates.forEach((template) => {
          const record = createRecord(template, null, template, pageData.page);
          records.push(record);
          recordByHandle.set(record.dataset.handle, record);
        });
        pageData.materialTemplates.forEach(([id, html]) => {
          if (!id || !html || deferredMaterialHtml.has(id)) return;
          deferredMaterialHtml.set(id, html);
        });
      };
      const setCatalogScope = (prefix, label) => {
        root.querySelectorAll('[data-catalog-scope-prefix]').forEach((node) => { node.textContent = prefix; });
        root.querySelectorAll('[data-catalog-scope-label]').forEach((node) => { node.textContent = label; });
      };
      const updateGlobalCounts = () => {
        const vendors = new Set(records.map((record) => record.dataset.vendor).filter(Boolean));
        const available = records.filter((record) => record.dataset.available === 'true').length;
        const sale = records.filter((record) => record.dataset.sale === 'true').length;
        root.querySelectorAll('[data-global-product-count]').forEach((node) => { node.textContent = totalProducts; });
        root.querySelectorAll('[data-global-vendor-count]').forEach((node) => { node.textContent = vendors.size; });
        root.querySelectorAll('[data-global-available-count]').forEach((node) => { node.textContent = available; });
        root.querySelectorAll('[data-global-sale-count]').forEach((node) => { node.textContent = sale; });
        setCatalogScope('Produkte im', 'Sortiment');
      };
      const loadedPages = new Set([currentPage]);
      const pagePromises = new Map();
      let catalogPromise = null;
      let catalogFailure = null;
      const expectedCurrentItems = currentPage < totalPages
        ? productsPerPage
        : Math.max(0, totalProducts - (productsPerPage * (totalPages - 1)));
      const paginationShapeValid = totalPages === expectedTotalPages
        && currentPage <= totalPages
        && records.length === expectedCurrentItems
        && recordByHandle.size === records.length;
      let catalogReady = paginationShapeValid && totalPages === 1 && records.length === totalProducts;
      root.dataset.catalogState = catalogReady ? 'complete' : 'loading';
      const setCatalogStatus = (message, visible = false, announce = false) => {
        if (!catalogStatus) return;
        catalogStatus.setAttribute('aria-live', announce ? 'polite' : 'off');
        catalogStatus.textContent = message;
        catalogStatus.classList.toggle('is-visible', visible);
      };
      const sortRecords = () => records.sort((a,b) => Number(a.dataset.index || 0) - Number(b.dataset.index || 0));
      const finalizeCatalog = () => {
        if (!paginationShapeValid || loadedPages.size !== totalPages) return false;
        if (recordByHandle.size !== totalProducts || records.length !== totalProducts) {
          throw new Error(`Gesamtkatalog: ${recordByHandle.size} eindeutige statt ${totalProducts} erwartete Produkte`);
        }
        sortRecords();
        catalogReady = true;
        catalogFailure = null;
        root.dataset.catalogReady = 'true';
        root.dataset.catalogState = 'complete';
        state.visible = totalProducts;
        refreshFacetOptions();
        renderCategoryCounts();
        updateGlobalCounts();
        if (nativePagination) nativePagination.hidden = true;
        loadMore.hidden = true;
        setCatalogStatus(`Alle ${totalProducts} Produkte werden durchsucht.`);
        return true;
      };
      const showCatalogFailure = (error) => {
        catalogReady = false;
        catalogFailure = error;
        root.dataset.catalogReady = 'false';
        root.dataset.catalogState = 'incomplete';
        if (nativePagination) nativePagination.hidden = false;
        loadMore.hidden = true;
        [vendorSelect, typeSelect, coreProductSelect].forEach((select) => {
          select.disabled = true;
          select.setAttribute('aria-busy', 'false');
        });
        setCatalogScope('Produkte auf dieser Seite', '(unvollständig)');
        setCatalogStatus('Der Gesamtkatalog konnte nicht vollständig geladen werden. Ergebnisse aus lokalen Filtern sind unvollständig; die Seitennavigation bleibt verfügbar.', true, true);
        console.error('[Mini Power Katalog] Gesamtkatalog konnte nicht vollständig bestätigt werden.', error);
      };
      const fetchAndIngestPage = async (page) => {
        if (loadedPages.has(page)) return true;
        let pagePromise = pagePromises.get(page);
        if (!pagePromise) {
          pagePromise = fetchCatalogPage(page);
          pagePromises.set(page, pagePromise);
        }
        let pageData;
        try {
          pageData = await pagePromise;
        } finally {
          pagePromises.delete(page);
        }
        if (!loadedPages.has(page)) {
          ingestPage(pageData);
          loadedPages.add(page);
          sortRecords();
        }
        return true;
      };
      const nextCatalogPage = () => {
        for (let page = 1; page <= totalPages; page += 1) {
          if (!loadedPages.has(page)) return page;
        }
        return null;
      };
      if (catalogStatus) catalogStatus.textContent = catalogReady
        ? `Alle ${totalProducts} Produkte werden durchsucht.`
        : 'Gesamtkatalog wird bei Suche oder Filterung geladen.';
      const ensureFullCatalog = () => {
        if (catalogReady) return Promise.resolve(true);
        if (catalogPromise) return catalogPromise;
        if (!paginationShapeValid) {
          const error = new Error(`Gesamtkatalog: Seiteneinteilung ${totalPages}/${expectedTotalPages} oder Startseite ist unvollständig`);
          showCatalogFailure(error);
          return Promise.resolve(false);
        }
        root.setAttribute('aria-busy', 'true');
        root.dataset.catalogState = 'loading';
        setCatalogScope('Produkte werden', 'geladen');
        setCatalogStatus('Gesamtkatalog wird geladen …');
        const pages = Array.from({length: totalPages}, (_, index) => index + 1).filter((page) => !loadedPages.has(page));
        catalogPromise = (async () => {
          const failures = [];
          const fetchedPages = [];
          let cursor = 0;
          const worker = async () => {
            while (cursor < pages.length) {
              const page = pages[cursor++];
              try {
                fetchedPages.push(await fetchCatalogPage(page));
              } catch (error) {
                failures.push({ page, error });
              }
            }
          };
          await Promise.all(Array.from({length: Math.min(2, pages.length)}, worker));
          if (failures.length) {
            const detail = failures.map(({ page, error }) => `Seite ${page}: ${error.message}`).join('; ');
            throw new Error(detail);
          }
          const allHandles = new Set(recordByHandle.keys());
          fetchedPages.forEach((pageData) => {
            [...pageData.cards, ...pageData.templates].forEach((source) => {
              const handle = source.dataset.handle;
              if (!handle || allHandles.has(handle)) throw new Error(`Katalogseite ${pageData.page}: Produkt ${handle || '?'} wurde doppelt geliefert`);
              allHandles.add(handle);
            });
          });
          fetchedPages.sort((a, b) => a.page - b.page).forEach((pageData) => {
            ingestPage(pageData);
            loadedPages.add(pageData.page);
          });
          return finalizeCatalog();
        })().catch((error) => {
          if (!root.isConnected) return false;
          showCatalogFailure(error);
          return false;
        }).finally(() => {
          catalogPromise = null;
          root.removeAttribute('aria-busy');
        });
        return catalogPromise;
      };
      const ensureNextCatalogPage = async () => {
        if (catalogReady) return true;
        if (!paginationShapeValid) return ensureFullCatalog();
        const page = nextCatalogPage();
        if (!page) {
          try { return finalizeCatalog(); }
          catch (error) { showCatalogFailure(error); return false; }
        }
        root.setAttribute('aria-busy', 'true');
        setCatalogStatus(`Weitere Produkte werden geladen (Seite ${page} von ${totalPages}) …`);
        try {
          await fetchAndIngestPage(page);
          if (loadedPages.size === totalPages) return finalizeCatalog();
          setCatalogStatus(`${records.length} von ${totalProducts} Produkten sind geladen.`);
          return true;
        } catch (error) {
          showCatalogFailure(error);
          return false;
        } finally {
          root.removeAttribute('aria-busy');
        }
      };
      const priceMatch = (price) => state.price === 'all' || (state.price === 'under-100' ? price < 10000 : state.price === '100-500' ? price >= 10000 && price < 50000 : state.price === '500-1000' ? price >= 50000 && price < 100000 : price >= 100000);
      const categoryMatch = (record, terms = state.category) => {
        if (!terms || terms === 'all') return true;
        const haystack = normalize(record.dataset.search);
        return String(terms).split('|').map(normalize).filter(Boolean).some((term) => haystack.includes(term));
      };
      const renderCategoryCounts = () => root.querySelectorAll('[data-category-quick-filter]').forEach((button) => {
        const count = records.filter((record) => categoryMatch(record, button.dataset.categoryQuickFilter)).length;
        const node = button.querySelector('[data-category-count]');
        if (node) node.textContent = count;
      });
      const priceLabels = {'under-100':'Unter 100 €','100-500':'100–500 €','500-1000':'500–1.000 €','over-1000':'Ab 1.000 €'};
      const matches = (record) => (!state.search || normalize(record.dataset.search).includes(normalize(state.search))) && (state.status === 'all' || (state.status === 'available' ? record.dataset.available === 'true' : record.dataset.sale === 'true')) && priceMatch(Number(record.dataset.price)) && categoryMatch(record) && (!state.storageHandles || state.storageHandles.has(record.dataset.handle)) && (state.vendor === 'all' || record.dataset.vendor === state.vendor) && (state.productType === 'all' || record.dataset.productType === state.productType) && (state.coreProduct === 'all' || record.dataset.coreProduct === state.coreProduct);
      const renderActive = () => {
        const active=[];
        if(state.search) active.push(['search',`Suche: ${state.search}`]);
        if(state.status !== 'all') active.push(['status',state.status === 'available' ? 'Verfügbar' : 'Angebote']);
        if(state.price !== 'all') active.push(['price',priceLabels[state.price] || state.price]);
        if(state.category !== 'all') {
          const categoryButton = root.querySelector(`[data-category-quick-filter="${CSS.escape(state.category)}"]`);
          active.push(['category',categoryButton?.dataset.categoryLabel || 'Kategorie']);
        }
        if(state.storageHandles) active.push(['storage',state.storageLabel || 'Speicherauswahl']);
        if(state.vendor !== 'all') active.push(['vendor',`Marke: ${state.vendor}`]);
        if(state.productType !== 'all') active.push(['productType',`Typ: ${state.productType}`]);
        if(state.coreProduct !== 'all') active.push(['coreProduct',`Kernprodukt: ${state.coreProduct}`]);
        activeRow.replaceChildren();
        active.forEach(([key,label]) => {const button=document.createElement('button');button.type='button';button.dataset.clearKey=key;button.textContent=`${label} ×`;activeRow.append(button);});
        activeRow.hidden=active.length===0;
      };
      const syncButtons = () => {
        const setPressed = (button, selected) => {
          button.classList.toggle('is-active', selected);
          button.setAttribute('aria-pressed', String(selected));
          button.removeAttribute('aria-selected');
        };
        const noTextOrFacetCriteria = !state.search && state.vendor === 'all' && state.productType === 'all' && state.coreProduct === 'all';
        root.querySelectorAll('[data-filter-key="status"]').forEach((button) => setPressed(button, state.status === button.dataset.filterValue));
        root.querySelectorAll('[data-filter-key="price"]').forEach((button) => setPressed(button, state.price === button.dataset.filterValue));
        root.querySelectorAll('[data-quick-filter]').forEach((button) => setPressed(button,
          noTextOrFacetCriteria && !state.storageHandles && state.price === 'all' && state.category === 'all' && state.status === button.dataset.quickFilter
        ));
        root.querySelectorAll('[data-price-quick-filter]').forEach((button) => setPressed(button,
          noTextOrFacetCriteria && !state.storageHandles && state.status === 'all' && state.category === 'all' && state.price === button.dataset.priceQuickFilter
        ));
        root.querySelectorAll('[data-category-quick-filter]').forEach((button) => setPressed(button,
          noTextOrFacetCriteria && !state.storageHandles && state.status === 'all' && state.price === 'all' && state.category === button.dataset.categoryQuickFilter
        ));
        root.querySelectorAll('[data-storage-preset]').forEach((button) => setPressed(button,
          state.storagePreset === button.dataset.storagePreset
        ));
      };
      const hasActiveCatalogCriteria = () => Boolean(state.search)
        || state.status !== 'all'
        || state.price !== 'all'
        || state.category !== 'all'
        || Boolean(state.storageHandles)
        || state.vendor !== 'all'
        || state.productType !== 'all'
        || state.coreProduct !== 'all';
      const apply = () => {
        const hasCriteria=hasActiveCatalogCriteria();
        const filtered=records.filter(matches);
        const visibleRecords=(catalogReady || catalogFailure) ? filtered : filtered.slice(0,state.visible);
        const visibleCards=visibleRecords.map(ensureCard).filter(Boolean);
        const detachedCards=document.createDocumentFragment();
        records.forEach((record) => {
          const card=record.card;
          if(!card)return;
          card.hidden=true;
          if(card.parentNode===grid) detachedCards.append(card);
        });
        const nextCards=document.createDocumentFragment();
        visibleCards.forEach((card) => {card.hidden=false;nextCards.append(card);observeSecondaryMedia(card);});
        grid.append(nextCards);
        const incompleteResult=hasCriteria && !catalogReady;
        const resultTotal=!catalogReady && !hasCriteria ? totalProducts : filtered.length;
        const resultLabel=catalogFailure && !catalogReady
          ? (hasCriteria ? `mind. ${filtered.length}` : `${records.length} / ${totalProducts}`)
          : resultTotal;
        root.querySelectorAll('[data-filter-count],[data-result-count]').forEach((node) => {
          node.textContent=resultLabel;
        });
        root.querySelector('[data-empty]').hidden=incompleteResult || filtered.length!==0;
        if(nativePagination)nativePagination.hidden=catalogReady;
        loadMore.hidden=true;
        root.querySelector('[data-load-remaining]').textContent='';
        renderActive();
        syncButtons();
      };
      const applyAfterCatalog = () => ensureFullCatalog().then((ready) => {
        apply();
        return ready;
      });
      const initStorageFinder = () => {
        const finder = root.querySelector('[data-storage-shortfinder]');
        if (!finder) return;
        // Keep the hero's recommendation link useful when the quiz starts collapsed.
        if (finder.matches('details')) {
          const openFinder = () => { finder.open = true; };
          root.querySelectorAll('a[href="#speicher-finder"]').forEach((link) => link.addEventListener('click', openFinder));
          const openFromHash = () => { if (window.location.hash === '#speicher-finder') openFinder(); };
          window.addEventListener('hashchange', openFromHash);
          openFromHash();
        }
        const questionHost = finder.querySelector('[data-storage-question]');
        const resultsHost = finder.querySelector('[data-storage-results]');
        const stepLabel = finder.querySelector('[data-storage-step]');
        const percentLabel = finder.querySelector('[data-storage-percent]');
        const progressBar = finder.querySelector('[data-storage-progress]');
        const backButton = finder.querySelector('[data-storage-back]');
        const restartButton = finder.querySelector('[data-storage-restart]');
        const announcer = root.querySelector('[data-storage-announcer]');
        const motionBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        const catalogByHandle = new Map(STORAGE_PRODUCTS.map((product) => [product.h, product]));
        const euro = (value) => Number.isFinite(value)
          ? new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(value)
          : 'Preis im Produkt prüfen';
        const decimal = (value) => Number.isFinite(value)
          ? new Intl.NumberFormat('de-DE', { maximumFractionDigits: 2 }).format(value)
          : 'k. A.';
        const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
          '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
        })[character]);
        const recordRole = (record) => {
          if (!record) return 'exclude';
          const technical = catalogByHandle.get(record.dataset.handle);
          if (technical?.support || technical?.r === 'expansion') return 'extension';
          const liquidRole = record.dataset.storageRole;
          if (technical) return liquidRole === 'new' ? 'new' : 'retrofit';
          return ['new', 'retrofit', 'extension'].includes(liquidRole) ? liquidRole : 'exclude';
        };
        const recordIsAc = (record) => {
          const technical = catalogByHandle.get(record?.dataset.handle);
          return technical?.r === 'ac' || record?.dataset.storageAc === 'true';
        };
        const recordImage = (record, technical) => {
          const image = record?.card?.querySelector('.mp-uc-card-image-primary')
            || record?.template?.content?.querySelector('.mp-uc-card-image-primary');
          return image?.currentSrc || image?.src || technical?.img || '';
        };
        const liveProduct = (record) => {
          if (!record) return null;
          const technical = catalogByHandle.get(record.dataset.handle);
          const cents = Number(record.dataset.price);
          const liveCatalogPrice = Number.isFinite(cents) && cents > 0 ? cents / 100 : null;
          const role = recordRole(record);
          return {
            ...(technical || {}),
            h: record.dataset.handle,
            n: record.dataset.title,
            b: record.dataset.vendor || technical?.b || 'Mini Power',
            shop: record.dataset.url || technical?.shop || `/products/${record.dataset.handle}`,
            img: recordImage(record, technical),
            p: liveCatalogPrice ?? technical?.p ?? null,
            s: technical?.s === 'preorder' ? 'preorder' : record.dataset.available === 'true' ? 'stock' : 'out',
            role,
            ac: recordIsAc(record),
            verified: Boolean(technical),
            support: role === 'extension'
          };
        };
        const candidateProducts = () => records
          .map(liveProduct)
          .filter((product) => product && (product.role === 'new' || product.role === 'retrofit'));
        const livePrice = (product) => {
          const cents = Number(recordByHandle.get(product.h)?.dataset.price);
          return Number.isFinite(cents) && cents > 0 ? cents / 100 : product.p;
        };
        const liveAvailable = (product) => recordByHandle.get(product.h)?.dataset.available === 'true';
        const productStatus = (product) => product.s === 'preorder' ? 'preorder' : liveAvailable(product) ? 'stock' : product.s === 'out' ? 'out' : 'check';
        const worstStatus = (values) => values.includes('out') ? 'out' : values.includes('preorder') ? 'preorder' : values.includes('check') ? 'check' : 'stock';
        const packageFor = (base, target) => {
          const start = Number.isFinite(base.c) ? base.c : null;
          const basePrice = livePrice(base);
          if (!Number.isFinite(start)) return { capacity: null, price: basePrice, status: productStatus(base), meets: null, qty: 0, extension: null };
          if (start >= target) return { capacity: start, price: basePrice, status: productStatus(base), meets: true, qty: 0, extension: null };
          const relation = base.compat;
          const extension = relation ? catalogByHandle.get(relation.h) : null;
          if (!extension || !recordByHandle.has(extension.h) || !extension.support || !Number.isFinite(extension.c)) {
            return { capacity: start, price: basePrice, status: productStatus(base), meets: false, qty: 0, extension: null };
          }
          let quantity = Math.max(1, Math.ceil((target - start) / extension.c));
          quantity = Math.min(quantity, Number(relation.n || quantity));
          let capacity = start + quantity * extension.c;
          if (Number.isFinite(base.x) && capacity > base.x) {
            quantity = Math.max(0, Math.floor((base.x - start) / extension.c));
            capacity = start + quantity * extension.c;
          }
          const extensionPrice = livePrice(extension);
          return {
            capacity,
            price: Number.isFinite(basePrice) && Number.isFinite(extensionPrice) ? basePrice + quantity * extensionPrice : null,
            status: worstStatus([productStatus(base), productStatus(extension)]),
            meets: capacity >= target,
            qty: quantity,
            extension
          };
        };
        const scoreProduct = (product, answers) => {
          const packageData = packageFor(product, Number(answers.capacity));
          const gaps = [];
          let score = answers.project === 'open' ? 12 : 22;
          if (answers.project === 'acRetrofit') score += product.ac ? 18 : 0;
          if (answers.coupling === 'ac') {
            if (product.ac) score += 14;
            else gaps.push('AC-Kopplung nicht bestätigt');
          } else if (answers.coupling === 'pv') {
            if (product.verified && (product.r === 'balcony' || product.r === 'inverter')) score += 14;
            else if (!product.ac) {
              score += 5;
              gaps.push('PV/DC-Kopplung auf der Produktseite prüfen');
            } else gaps.push('PV/DC-Kopplung nicht bestätigt');
          } else score += answers.coupling === 'either' ? 10 : 8;
          const targetCapacity = Number(answers.capacity);
          if (Number.isFinite(packageData.capacity)) {
            score += 18 * Math.min(packageData.capacity / targetCapacity, 1);
            if (!packageData.meets) gaps.push(`Kapazitätsziel ${decimal(targetCapacity)} kWh noch nicht erreicht`);
          } else {
            score += 4;
            gaps.push('Kapazität auf der Produktseite prüfen');
          }
          if (answers.grid === 'open') score += 12;
          else if (answers.grid === 'va800') {
            if (product.va === 'confirmed800') score += 12;
            else gaps.push('800-VA-Nachweis für den exakten Gerätetyp prüfen');
          } else if (Number.isFinite(product.g)) {
            score += 12 * Math.min(product.g / Number(answers.grid), 1);
            if (product.g < Number(answers.grid)) gaps.push('Gewünschte netzgekoppelte Leistung nicht erreicht');
          } else gaps.push('Netzleistung auf der Produktseite prüfen');
          if (Number(answers.backup) === 0) score += 10;
          else if (Number.isFinite(product.o)) {
            score += 10 * Math.min(product.o / Number(answers.backup), 1);
            if (product.o < Number(answers.backup)) gaps.push('Gewünschte Notstromleistung nicht erreicht');
          } else gaps.push('Notstromleistung auf der Produktseite prüfen');
          if (Number(answers.expand) === 0) score += 8;
          else if (Number.isFinite(product.x)) {
            score += 8 * Math.min(product.x / Number(answers.expand), 1);
            if (product.x < Number(answers.expand)) gaps.push('Gewünschte Ausbaukapazität nicht erreicht');
          } else gaps.push('Erweiterbarkeit auf der Produktseite prüfen');
          const budget = answers.budget === 'open' ? Infinity : Number(answers.budget);
          if (budget === Infinity) score += 8;
          else if (Number.isFinite(packageData.price)) {
            score += 8 * Math.min(budget / packageData.price, 1);
            if (packageData.price > budget) gaps.push('Gewählter Preisrahmen wird überschritten');
          } else gaps.push('Preis auf der Produktseite prüfen');
          if (packageData.status === 'stock') score += 5;
          if (product.verified) score += 3;
          return { product, packageData, gaps: [...new Set(gaps)], score: Math.round(Math.min(100, score)) };
        };
        const selectDiverse = (rows) => {
          const selected = [];
          const brandCounts = new Map();
          for (const row of rows) {
            if ((brandCounts.get(row.product.b) || 0) >= 2) continue;
            selected.push(row);
            brandCounts.set(row.product.b, (brandCounts.get(row.product.b) || 0) + 1);
            if (selected.length === 4) break;
          }
          if (selected.length < Math.min(2, rows.length)) {
            rows.forEach((row) => {
              if (selected.includes(row) || selected.length >= Math.min(4, rows.length)) return;
              selected.push(row);
            });
          }
          return selected;
        };
        const recommend = (answers) => {
          const allCandidates = candidateProducts();
          const desiredRole = answers.project === 'new' ? 'new' : answers.project === 'open' ? null : 'retrofit';
          const sameRole = desiredRole ? allCandidates.filter((product) => product.role === desiredRole) : allCandidates;
          const requiresConfirmedAc = answers.project === 'acRetrofit' || answers.coupling === 'ac';
          const strictPool = requiresConfirmedAc ? sameRole.filter((product) => product.ac) : sameRole;
          const pool = strictPool.length >= 2 ? strictPool : sameRole;
          const rows = pool
            .map((product) => scoreProduct(product, answers))
            .sort((a, b) => b.score - a.score
              || Number(liveAvailable(b.product)) - Number(liveAvailable(a.product))
              || (a.packageData.price ?? Infinity) - (b.packageData.price ?? Infinity)
              || a.product.n.localeCompare(b.product.n, 'de'));
          return selectDiverse(rows);
        };
        const couplingLabel = (product) => product.ac ? 'AC-gekoppelt' : product.verified ? product.r === 'inverter' ? 'PV / Hybrid' : 'PV/DC-gekoppelt' : 'Produktseite prüfen';
        const statusLabel = (status) => status === 'stock' ? 'Aktuell verfügbar' : status === 'preorder' ? 'Vorbestellung' : status === 'out' ? 'Nicht auf Lager' : 'Verfügbarkeit prüfen';
        const packageLabel = (row) => {
          if (!Number.isFinite(row.packageData.capacity)) return 'Kapazität und Konfiguration auf der Produktseite prüfen';
          const extension = row.packageData.extension;
          if (extension && row.packageData.qty > 0) return `${row.product.n} + ${row.packageData.qty} × ${extension.n}`;
          return 'Hauptgerät ohne zusätzliche Erweiterungsbatterie';
        };
        const applyStorageFilter = async (handles, label, preset = 'quiz') => {
          state.search = '';
          state.status = 'all';
          state.price = 'all';
          state.category = 'all';
          state.vendor = 'all';
          state.productType = 'all';
          state.coreProduct = 'all';
          state.storagePreset = preset;
          state.storageLabel = label;
          state.storageHandles = new Set(handles);
          search.value = '';
          vendorSelect.value = 'all';
          typeSelect.value = 'all';
          coreProductSelect.value = 'all';
          state.visible = Number(root.dataset.initialProducts || 12);
          await applyAfterCatalog();
          root.querySelector('#mp-universal-products')?.scrollIntoView({ behavior: motionBehavior, block: 'start' });
        };
        let resultRequest = 0;
        const renderResults = async (answers) => {
          const requestId = ++resultRequest;
          finder.setAttribute('aria-busy', 'true');
          const catalogComplete = await ensureFullCatalog();
          if (requestId !== resultRequest) return;
          if (!catalogComplete) {
            finder.removeAttribute('aria-busy');
            resultsHost.hidden = false;
            resultsHost.innerHTML = `<div class="mp-storage-results-head"><div><span>DATEN NOCH NICHT VOLLSTÄNDIG</span><h3>Der vollständige Katalog konnte gerade nicht geladen werden.</h3></div><button type="button" data-storage-retry>Erneut versuchen</button></div><p>Damit keine unvollständige Auswahl als Empfehlung erscheint, zeigen wir erst nach erfolgreichem Laden aller Produkte Kandidaten an.</p>`;
            announcer.textContent = 'Der vollständige Katalog konnte nicht geladen werden. Bitte erneut versuchen.';
            resultsHost.scrollIntoView({ behavior: motionBehavior, block: 'start' });
            return;
          }
          const rows = recommend(answers);
          finder.removeAttribute('aria-busy');
          resultsHost.hidden = false;
          const cards = rows.map((row, index) => {
            const { product, packageData } = row;
            const capacityText = Number.isFinite(packageData.capacity) ? `${decimal(packageData.capacity)} kWh` : 'Produktseite prüfen';
            const gapText = row.gaps.length
              ? `<p class="mp-storage-result-gap"><strong>Bitte prüfen:</strong> ${escapeHtml(row.gaps.join(' · '))}</p>`
              : '<p class="mp-storage-result-gap is-confirmed"><strong>Bestätigte Daten:</strong> Die gewählten Anforderungen werden erreicht.</p>';
            return `<article class="mp-storage-result-card${index === 0 ? ' is-best' : ''}">
              <span class="mp-storage-result-rank">${index === 0 ? 'Beste Passung' : `${index + 1}. Kandidat`}</span>
              <img loading="lazy" src="${escapeHtml(product.img)}" alt="${escapeHtml(product.n)}">
              <span class="mp-storage-result-brand">${escapeHtml(product.b)}</span>
              <h4>${escapeHtml(product.n)}</h4>
              <div class="mp-storage-result-facts">
                <span>Kapazität<strong>${capacityText}</strong></span>
                <span>Paketpreis ab<strong>${euro(packageData.price)}</strong></span>
                <span>Kopplung<strong>${couplingLabel(product)}</strong></span>
                <span>Paketstatus<strong>${statusLabel(packageData.status)}</strong></span>
              </div>
              <p class="mp-storage-result-package"><strong>Passende Konfiguration:</strong> ${escapeHtml(packageLabel(row))}</p>
              ${gapText}
              <a href="${escapeHtml(product.shop)}">Produkt ansehen <span aria-hidden="true">→</span></a>
            </article>`;
          }).join('');
          const handles = rows.map((row) => row.product.h);
          resultsHost.innerHTML = `<div class="mp-storage-results-head"><div><span>DEINE KURZAUSWAHL</span><h3>${rows.length} bestpassende Kandidaten aus ${records.length} Katalogprodukten.</h3></div><button type="button" data-storage-edit>Antworten ändern</button></div><p class="mp-storage-results-note">Die Rangfolge zeigt immer die 2–4 nächstliegenden Produkte derselben Einbauart. Abweichungen und noch zu bestätigende Daten bleiben sichtbar.</p><div class="mp-storage-result-grid">${cards}</div><div class="mp-storage-results-actions"><button type="button" data-storage-show-candidates>Kandidaten im Sortiment anzeigen</button><a href="#mp-storage-brands">Oder nach Marke auswählen →</a></div>`;
          resultsHost.querySelector('[data-storage-show-candidates]')?.addEventListener('click', () => applyStorageFilter(handles, `Quiz-Ergebnis: ${handles.length} Kandidaten`));
          announcer.textContent = `${rows.length} bestpassende Kandidaten aus ${records.length} Katalogprodukten wurden gefunden.`;
          resultsHost.scrollIntoView({ behavior: motionBehavior, block: 'start' });
        };
        let step = 0;
        let answers = {};
        const clearResults = () => {
          resultRequest += 1;
          finder.removeAttribute('aria-busy');
          resultsHost.hidden = true;
          resultsHost.replaceChildren();
        };
        const renderQuestion = () => {
          const question = STORAGE_QUESTIONS[step];
          const picked = answers[question.key];
          const percent = Math.round(((step + 1) / STORAGE_QUESTIONS.length) * 100);
          stepLabel.textContent = `Frage ${step + 1} von ${STORAGE_QUESTIONS.length}`;
          percentLabel.textContent = `${percent} %`;
          progressBar.style.width = `${percent}%`;
          backButton.disabled = step === 0;
          questionHost.innerHTML = `<fieldset class="mp-storage-question"><legend>${escapeHtml(question.title)}</legend><p>${escapeHtml(question.help)}</p><div class="mp-storage-option-grid">${question.options.map((option, index) => `<button type="button" class="mp-storage-option${Object.is(picked, option[0]) ? ' is-selected' : ''}" data-storage-answer="${index}" aria-pressed="${Object.is(picked, option[0])}"><span>${index + 1}</span><span><strong>${escapeHtml(option[1])}</strong><small>${escapeHtml(option[2])}</small></span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>`).join('')}</div></fieldset>`;
          questionHost.querySelectorAll('[data-storage-answer]').forEach((button) => {
            button.addEventListener('click', async () => {
              if (button.disabled) return;
              const option = question.options[Number(button.dataset.storageAnswer)];
              answers[question.key] = option[0];
              questionHost.querySelectorAll('[data-storage-answer]').forEach((candidate) => {
                const selected = candidate === button;
                candidate.classList.toggle('is-selected', selected);
                candidate.setAttribute('aria-pressed', String(selected));
                candidate.disabled = true;
              });
              if (step < STORAGE_QUESTIONS.length - 1) {
                step += 1;
                renderQuestion();
                questionHost.querySelector('button')?.focus({ preventScroll: true });
              } else {
                await renderResults(answers);
              }
            });
          });
        };
        const restart = () => {
          step = 0;
          answers = {};
          clearResults();
          renderQuestion();
          finder.scrollIntoView({ behavior: motionBehavior, block: 'start' });
        };
        backButton.addEventListener('click', () => {
          if (step === 0) return;
          clearResults();
          step -= 1;
          renderQuestion();
        });
        restartButton.addEventListener('click', restart);
        resultsHost.addEventListener('click', (event) => {
          if (event.target.closest('[data-storage-retry]')) renderResults({ ...answers });
          if (event.target.closest('[data-storage-edit]')) restart();
        });
        const presetButtons = Array.from(root.querySelectorAll('[data-storage-preset]'));
        const presetMatches = (record, preset) => {
          const role = recordRole(record);
          if (preset === 'new') return role === 'new';
          if (preset === 'retrofit') return role === 'retrofit';
          if (preset === 'ac') return role === 'retrofit' && recordIsAc(record);
          if (preset === 'extension') return role === 'extension';
          return false;
        };
        const presetHandles = (preset) => records.filter((record) => presetMatches(record, preset)).map((record) => record.dataset.handle);
        const refreshPresetCounts = () => presetButtons.forEach((button) => {
          const preset = button.dataset.storagePreset;
          const count = button.querySelector(`[data-storage-preset-count="${preset}"]`);
          if (count) count.textContent = presetHandles(preset).length;
        });
        presetButtons.forEach((button) => {
          const preset = button.dataset.storagePreset;
          const definition = STORAGE_PRESETS[preset];
          button.addEventListener('click', async () => {
            const catalogComplete = await ensureFullCatalog();
            if (!catalogComplete) {
              announcer.textContent = 'Der vollständige Katalog konnte nicht geladen werden. Bitte erneut versuchen.';
              return;
            }
            refreshPresetCounts();
            await applyStorageFilter(presetHandles(preset), definition.label, preset);
          });
        });
        const selfCheck = () => {
          const errors = [];
          if (STORAGE_QUESTIONS.length !== 7) errors.push('question-count');
          if (STORAGE_QUESTIONS.some((question) => question.options.length !== 4)) errors.push('option-count');
          if (new Set(STORAGE_PRODUCTS.map((product) => product.h)).size !== STORAGE_PRODUCTS.length) errors.push('catalog-identity');
          if (STORAGE_PRODUCTS.some((product) => !product.support && product.compat && !catalogByHandle.has(product.compat.h))) errors.push('compat-target');
          if (candidateProducts().some((product) => product.support || product.role === 'extension')) errors.push('candidate-role');
          if (catalogReady) {
            if (records.length < 120) errors.push('catalog-source');
            if (candidateProducts().filter((product) => product.role === 'new').length < 2) errors.push('new-pool');
            if (candidateProducts().filter((product) => product.role === 'retrofit').length < 2) errors.push('retrofit-pool');
            if (presetHandles('ac').length < 2) errors.push('ac-pool');
            if (presetHandles('extension').length < 1) errors.push('extension-pool');
          }
          return errors;
        };
        const commitSelfCheck = () => {
          const errors = selfCheck();
          root.dataset.storageSelfCheck = errors.join(',') || 'ok';
          if (errors.length) console.error('MP storage short finder self-check failed', errors);
        };
        ensureFullCatalog().then((catalogComplete) => {
          if (catalogComplete) refreshPresetCounts();
          commitSelfCheck();
        });
        commitSelfCheck();
        root._mpStorageShortfinder = {
          questions: STORAGE_QUESTIONS,
          recommend,
          selfCheck,
          catalogCount: () => records.length,
          candidateCount: () => candidateProducts().length,
          roleCounts: () => Object.fromEntries(['new', 'retrofit', 'extension', 'exclude'].map((role) => [role, records.filter((record) => recordRole(record) === role).length])),
          presetCounts: () => Object.fromEntries(Object.keys(STORAGE_PRESETS).map((preset) => [preset, presetHandles(preset).length]))
        };
        renderQuestion();
      };
      initStorageFinder();
      let loadMorePromise=null;
      const loadMoreProducts = () => {
        if(loadMorePromise)return loadMorePromise;
        const button=loadMore.querySelector('button');
        loadMore.setAttribute('aria-busy','true');
        if(button)button.disabled=true;
        loadMorePromise=(async()=>{
          const batch=Number(root.dataset.initialProducts || 12);
          const hasCriteria=hasActiveCatalogCriteria();
          if(hasCriteria){
            const ready=await ensureFullCatalog();
            if(!ready){apply();return false;}
            state.visible=Math.min(state.visible+batch,records.filter(matches).length);
            apply();
            return true;
          }
          let localMatches=records.filter(matches);
          if(state.visible>=localMatches.length && !catalogReady){
            if(currentPage>1){apply();return true;}
            const loaded=await ensureNextCatalogPage();
            if(!loaded){apply();return false;}
            localMatches=records.filter(matches);
          }
          state.visible=Math.min(state.visible+batch,catalogReady ? totalProducts : localMatches.length);
          apply();
          return true;
        })().finally(()=>{
          loadMorePromise=null;
          loadMore.removeAttribute('aria-busy');
          if(button)button.disabled=false;
        });
        return loadMorePromise;
      };
      const reset = () => {Object.assign(state,{search:'',status:'all',price:'all',category:'all',vendor:'all',productType:'all',coreProduct:'all',storagePreset:'all',storageLabel:'',storageHandles:null,visible:Number(root.dataset.initialProducts || 12)});search.value='';vendorSelect.value='all';typeSelect.value='all';coreProductSelect.value='all';syncButtons();apply();};
      const searchForm = search.closest('form');
      if (searchForm) searchForm.addEventListener('submit',(event) => {
        event.preventDefault();
        event.stopPropagation();
        state.search=search.value.trim();
        state.visible=Number(root.dataset.initialProducts || 12);
        applyAfterCatalog();
      });
      const searchClear = root.querySelector('[data-search-clear]');
      const openFilters=() => {filters.classList.add('is-open');backdrop.hidden=false;document.documentElement.style.overflow='hidden';if(!catalogReady)applyAfterCatalog();};
      const closeFilters=() => {filters.classList.remove('is-open');backdrop.hidden=true;document.documentElement.style.overflow='';};
      const primeCatalogFromFilters=() => {if(!catalogReady)applyAfterCatalog();};
      filters.addEventListener('pointerenter',primeCatalogFromFilters,{once:true});
      filters.addEventListener('focusin',primeCatalogFromFilters,{once:true});
      const sortUrl = root.querySelector('[data-sort-url]');
      const shippingDialog=root.querySelector('[data-shipping-dialog]');
      let shippingOpener=null;
      let searchTimer=0;
      let activeMaterialDialog=null;
      const materialThumbs=(dialog)=>Array.from(dialog?.querySelectorAll('[data-material-thumb]') || []);
      const materialIndex=(dialog)=>{
        const index=Number.parseInt(dialog?.dataset.materialIndex || '0',10);
        return Number.isFinite(index) ? index : 0;
      };
      const setMaterialImage=(dialog,requestedIndex,{focusThumb=false,scrollThumb=true}={})=>{
        if(!dialog)return false;
        const thumbs=materialThumbs(dialog);
        if(!thumbs.length){
          dialog.querySelectorAll('[data-material-prev],[data-material-next]').forEach((button)=>{
            button.disabled=true;
            button.setAttribute('aria-disabled','true');
          });
          return false;
        }
        const index=((Number(requestedIndex)%thumbs.length)+thumbs.length)%thumbs.length;
        const thumb=thumbs[index];
        const image=dialog.querySelector('.mp-uc-material-image') || dialog.querySelector('.mp-uc-material-main img');
        const nextSource=thumb.dataset.src;
        if(image && nextSource){
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src=nextSource;
          image.alt=thumb.dataset.alt || '';
          image.dataset.materialIndex=String(index);
        }
        dialog.dataset.materialIndex=String(index);
        thumbs.forEach((candidate,candidateIndex)=>{
          const selected=candidateIndex===index;
          candidate.classList.toggle('is-active',selected);
          candidate.setAttribute('aria-selected',String(selected));
          candidate.tabIndex=selected ? 0 : -1;
        });
        const counter=dialog.querySelector('[data-material-counter]') || dialog.querySelector('.mp-uc-material-main > span');
        if(counter)counter.textContent=`${index+1} / ${thumbs.length}`;
        dialog.querySelectorAll('[data-material-prev],[data-material-next]').forEach((button)=>{
          button.disabled=thumbs.length<2;
          button.setAttribute('aria-disabled',String(thumbs.length<2));
        });
        if(scrollThumb)thumb.scrollIntoView({block:'nearest',inline:'nearest'});
        if(focusThumb)thumb.focus({preventScroll:true});
        return true;
      };
      const stepMaterialImage=(dialog,step,options)=>setMaterialImage(dialog,materialIndex(dialog)+step,options);
      const initializeMaterialDialog=(dialog)=>{
        const thumbs=materialThumbs(dialog);
        thumbs.forEach((thumb,index)=>{if(!thumb.dataset.materialIndex)thumb.dataset.materialIndex=String(index);});
        const initiallyActive=Math.max(0,thumbs.findIndex((thumb)=>thumb.classList.contains('is-active')));
        setMaterialImage(dialog,initiallyActive,{scrollThumb:false});
        const stage=dialog.querySelector('[data-material-stage]');
        if(!stage)return;
        let swipe=null;
        stage.addEventListener('pointerdown',(event)=>{
          if(event.pointerType==='mouse')return;
          swipe={id:event.pointerId,x:event.clientX,y:event.clientY};
        });
        stage.addEventListener('pointerup',(event)=>{
          if(!swipe || swipe.id!==event.pointerId)return;
          const deltaX=event.clientX-swipe.x;
          const deltaY=event.clientY-swipe.y;
          swipe=null;
          if(Math.abs(deltaX)<48 || Math.abs(deltaX)<=Math.abs(deltaY))return;
          stepMaterialImage(dialog,deltaX<0 ? 1 : -1);
        });
        stage.addEventListener('pointercancel',()=>{swipe=null;});
      };
      const openMaterialDialog=(button) => {
        if(activeMaterialDialog?.isConnected && activeMaterialDialog.open){
          activeMaterialDialog.querySelector('[data-dialog-close]')?.focus();
          return;
        }
        activeMaterialDialog?.remove();
        activeMaterialDialog=null;
        const dialogId=button.dataset.materialOpen;
        const template=root.querySelector(`template[data-material-template="${CSS.escape(dialogId)}"]`);
        let source=template?.content.querySelector('dialog');
        if(!source && deferredMaterialHtml.has(dialogId)){
          const holder=document.createElement('template');
          holder.innerHTML=deferredMaterialHtml.get(dialogId);
          source=holder.content.querySelector('dialog');
        }
        if(!source)return;
        const dialog=source.cloneNode(true);
        dialog.dataset.dynamicMaterial='true';
        dialog.dataset.materialTemplateId=dialogId;
        activeMaterialDialog=dialog;
        root.append(dialog);
        dialog.scrollTop=0;
        const copy=dialog.querySelector('.mp-uc-material-copy');
        if(copy)copy.scrollTop=0;
        initializeMaterialDialog(dialog);
        dialog.addEventListener('close',() => {
          if(activeMaterialDialog===dialog)activeMaterialDialog=null;
          dialog.remove();
          if(button.isConnected)button.focus();
        },{once:true});
        try{dialog.showModal();}
        catch(error){
          if(activeMaterialDialog===dialog)activeMaterialDialog=null;
          dialog.remove();
          console.error('[Mini Power Katalog] Materialansicht konnte nicht geöffnet werden.',error);
        }
      };
      const openShippingDialog=(button) => {
        if(!shippingDialog)return;
        const card=button.closest('[data-card]');
        const taxNote=card?.querySelector('[data-card-price-note]')?.textContent?.trim();
        const deliveryNote=card?.querySelector('[data-card-delivery-text]')?.textContent?.trim();
        const taxSelector=document.querySelector('#mp-tax-selector');
        const countryLabel=document.querySelector('#mp-tax-country option:checked')?.textContent?.trim();
        const role=taxSelector?.querySelector('[data-mp-tax-role][aria-pressed="true"]')?.dataset.mpTaxRole;
        const roleLabel=role==='business'?'Geschäftskunde':role==='private'?'Privatkunde':'';
        shippingDialog.querySelector('[data-shipping-context]').textContent=['Aktuelle Auswahl',countryLabel,roleLabel].filter(Boolean).join(' · ');
        shippingDialog.querySelector('[data-shipping-tax-note]').textContent=taxNote||'Preis gemäß aktueller Shop-Einstellung';
        shippingDialog.querySelector('[data-shipping-delivery-note]').textContent=deliveryNote||'Lieferzeit: auf der Produktseite prüfen';
        shippingDialog.scrollTop=0;
        shippingOpener=button;
        shippingDialog.showModal();
      };
      root.addEventListener('keydown',(event)=>{
        const dialog=event.target.closest?.('.mp-uc-material-dialog');
        const gallery=event.target.closest?.('.mp-uc-material-gallery');
        if(!dialog || !gallery || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
        event.preventDefault();
        const thumbs=materialThumbs(dialog);
        const index=event.key==='Home' ? 0 : event.key==='End' ? thumbs.length-1 : materialIndex(dialog)+(event.key==='ArrowRight' ? 1 : -1);
        setMaterialImage(dialog,index,{focusThumb:Boolean(event.target.closest?.('[data-material-thumb]'))});
      });
      root.addEventListener('input',(event) => {
        if(event.target!==search)return;
        window.clearTimeout(searchTimer);
        searchTimer=window.setTimeout(() => {
          state.search=search.value.trim();
          state.visible=Number(root.dataset.initialProducts || 12);
          applyAfterCatalog();
        },180);
      });
      root.addEventListener('change',(event) => {
        if(event.target===vendorSelect)state.vendor=vendorSelect.value;
        else if(event.target===typeSelect)state.productType=typeSelect.value;
        else if(event.target===coreProductSelect)state.coreProduct=coreProductSelect.value;
        else if(event.target===sortUrl){
          const url=new URL(window.location.href);
          url.searchParams.set('sort_by',sortUrl.value);
          url.searchParams.set('view',root.dataset.view);
          window.location.assign(url.toString());
          return;
        }else return;
        applyAfterCatalog();
      });
      root.addEventListener('click',async (event) => {
        const target=event.target;
        const panelButton=target.closest('[data-panel-value]');
        if(panelButton){
          const card=panelButton.closest('[data-card]');
          const panel=card?._mpPanelSelector;
          if(panel){
            const variant=panel.selectVariant(panelButton.dataset.panelValue);
            const requestId=Number(card._mpTaxVariantRequestId || 0) + 1;
            card._mpTaxVariantRequestId=requestId;
            if(!variant || String(card.dataset.mpTaxVariantId || '')===String(variant.id)){
              card.removeAttribute('aria-busy');
              return;
            }
            card.setAttribute('aria-busy','true');
            const taxReady=await ensureTaxVariant(card,variant);
            if(card._mpTaxVariantRequestId!==requestId)return;
            card.removeAttribute('aria-busy');
            if(!taxReady)return;
            panel.renderVariant(variant);
            apply();
          }
          return;
        }
        const filterButton=target.closest('[data-filter-key]');
        if(filterButton){
          state[filterButton.dataset.filterKey]=filterButton.dataset.filterValue;
          state.visible=Number(root.dataset.initialProducts || 12);
          syncButtons();
          applyAfterCatalog();
          return;
        }
        const quickButton=target.closest('[data-quick-filter]');
        if(quickButton){
          state.status=quickButton.dataset.quickFilter;
          state.price='all';
          state.category='all';
          state.visible=Number(root.dataset.initialProducts || 12);
          syncButtons();
          applyAfterCatalog();
          root.querySelector('#mp-universal-products').scrollIntoView({behavior:'smooth',block:'start'});
          return;
        }
        const priceButton=target.closest('[data-price-quick-filter]');
        if(priceButton){
          state.status='all';
          state.price=priceButton.dataset.priceQuickFilter;
          state.visible=Number(root.dataset.initialProducts || 12);
          syncButtons();
          applyAfterCatalog();
          root.querySelector('#mp-universal-products').scrollIntoView({behavior:'smooth',block:'start'});
          return;
        }
        const categoryButton=target.closest('[data-category-quick-filter]');
        if(categoryButton){
          state.search='';
          state.status='all';
          state.price='all';
          state.vendor='all';
          state.productType='all';
          state.coreProduct='all';
          state.storagePreset='all';
          state.storageLabel='';
          state.storageHandles=null;
          state.category=categoryButton.dataset.categoryQuickFilter;
          search.value='';
          vendorSelect.value='all';
          typeSelect.value='all';
          coreProductSelect.value='all';
          state.visible=Number(root.dataset.initialProducts || 12);
          syncButtons();
          applyAfterCatalog();
          root.querySelector('#mp-universal-products').scrollIntoView({behavior:'smooth',block:'start'});
          return;
        }
        const clearButton=target.closest('[data-clear-key]');
        if(clearButton){
          const key=clearButton.dataset.clearKey;
          if(key==='search'){state.search='';search.value='';}
          else if(key==='storage'){state.storagePreset='all';state.storageLabel='';state.storageHandles=null;}
          else{
            state[key]='all';
            if(key==='vendor')vendorSelect.value='all';
            if(key==='productType')typeSelect.value='all';
            if(key==='coreProduct')coreProductSelect.value='all';
          }
          syncButtons();
          applyAfterCatalog();
          return;
        }
        if(searchClear && target.closest('[data-search-clear]')){
          window.clearTimeout(searchTimer);
          state.search='';
          search.value='';
          applyAfterCatalog();
          search.focus();
          return;
        }
        if(target.closest('[data-reset]')){reset();return;}
        if(target.closest('[data-scroll-products]')){
          root.querySelector('#mp-universal-products').scrollIntoView({behavior:'smooth',block:'start'});
          return;
        }
        if(target.closest('[data-load-more] button')){
          loadMoreProducts();
          return;
        }
        if(target.closest('[data-filter-open]')){openFilters();return;}
        if(target.closest('[data-filter-close]') || target.closest('[data-filter-backdrop]')){closeFilters();return;}
        const materialButton=target.closest('[data-material-open]');
        if(materialButton){openMaterialDialog(materialButton);return;}
        const shippingButton=target.closest('[data-shipping-payment-open]');
        if(shippingButton){openShippingDialog(shippingButton);return;}
        const closeButton=target.closest('[data-dialog-close]');
        if(closeButton){closeButton.closest('dialog')?.close();return;}
        const materialStepButton=target.closest('[data-material-prev],[data-material-next]');
        if(materialStepButton){
          const dialog=materialStepButton.closest('.mp-uc-material-dialog');
          stepMaterialImage(dialog,materialStepButton.matches('[data-material-next]') ? 1 : -1);
          return;
        }
        const thumbButton=target.closest('[data-material-thumb]');
        if(thumbButton){
          const dialog=thumbButton.closest('.mp-uc-material-dialog');
          const index=Number.parseInt(thumbButton.dataset.materialIndex || '',10);
          setMaterialImage(dialog,Number.isFinite(index) ? index : materialThumbs(dialog).indexOf(thumbButton));
          return;
        }
        if(target.matches('dialog'))target.close();
      });
      shippingDialog?.addEventListener('close',() => {shippingOpener?.focus();shippingOpener=null;});
      const tray=root.querySelector('[data-compare-tray]');
      const compareItems=root.querySelector('[data-compare-items]');
      const compareOpen=root.querySelector('[data-compare-open]');
      const compareDialog=root.querySelector('[data-compare-dialog]');
      const compareNotice=root.querySelector('[data-compare-notice]');
      const renderCompare=() => {compareItems.replaceChildren();state.selected.forEach((handle) => {const record=recordByHandle.get(handle);if(!record)return;const button=document.createElement('button');button.type='button';button.dataset.removeCompare=handle;const span=document.createElement('span');span.textContent=record.dataset.title;const close=document.createElement('i');close.textContent='×';button.append(span,close);compareItems.append(button);});root.querySelector('[data-compare-count]').textContent=state.selected.length;tray.hidden=state.selected.length===0;compareOpen.disabled=state.selected.length<2;records.forEach((record) => {const button=record.card?.querySelector('[data-compare]');if(!button)return;const selected=state.selected.includes(record.dataset.handle);button.classList.toggle('is-selected',selected);button.textContent=selected?'✓ Ausgewählt':'+ Vergleichen';});};
      root.addEventListener('click',(event) => {const button=event.target.closest('[data-compare]');if(!button)return;const card=button.closest('[data-card]');const handle=card.dataset.handle;if(state.selected.includes(handle))state.selected=state.selected.filter((value) => value!==handle);else if(state.selected.length>=3){compareNotice.hidden=false;compareNotice.textContent='Maximal drei Produkte gleichzeitig vergleichen.';return;}else state.selected.push(handle);compareNotice.hidden=true;renderCompare();});
      compareItems.addEventListener('click',(event) => {const button=event.target.closest('[data-remove-compare]');if(!button)return;state.selected=state.selected.filter((value) => value!==button.dataset.removeCompare);renderCompare();});
      compareOpen.addEventListener('click',() => {const table=root.querySelector('[data-compare-table]');table.replaceChildren();const selectedRecords=state.selected.map((handle) => recordByHandle.get(handle)).filter(Boolean);const columns=`150px repeat(${selectedRecords.length},minmax(180px,1fr))`;const rows=[['Produkt','title'],['Marke','vendor'],['Produkttyp','productType'],['Varianten','variants'],['Startpreis','price'],['Status','available']];rows.forEach(([label,key]) => {const row=document.createElement('div');row.className='mp-uc-compare-row';row.style.gridTemplateColumns=columns;const heading=document.createElement('strong');heading.textContent=label;row.append(heading);selectedRecords.forEach((record) => {const cell=key==='title'?document.createElement('a'):document.createElement('span');if(key==='title')cell.href=record.dataset.url;cell.textContent=key==='price'?new Intl.NumberFormat('de-DE',{style:'currency',currency:'EUR'}).format(Number(record.dataset.price)/100):key==='available'?(record.dataset.available==='true'?'Verfügbar':'Ausverkauft'):record.dataset[key];row.append(cell);});table.append(row);});compareDialog.showModal();});
      if(catalogReady){
        try{finalizeCatalog();}catch(error){showCatalogFailure(error);}
      }else if(!paginationShapeValid){
        showCatalogFailure(new Error(`Gesamtkatalog: Seiteneinteilung ${totalPages}/${expectedTotalPages} oder Startseite ist unvollständig`));
      }else{
        root.dataset.catalogReady='false';
      }
      syncButtons();
      apply();
      if (!catalogReady && !catalogFailure) {
        setCatalogScope('Produkte im', 'Sortiment');
      }
    };
    const cleanup = (root) => {
      root._mpTaxNoteObserver?.disconnect();
      root._mpSecondaryMediaObserver?.disconnect();
      if (root._mpSecondaryScrollScan) window.removeEventListener('scroll', root._mpSecondaryScrollScan);
      if (root._mpSecondaryIntent) {
        root.removeEventListener('pointerover', root._mpSecondaryIntent);
        root.removeEventListener('pointerdown', root._mpSecondaryIntent);
        root.removeEventListener('focusin', root._mpSecondaryIntent);
      }
      if (root._mpSecondaryEnable) {
        root.removeEventListener('wheel', root._mpSecondaryEnable);
        root.removeEventListener('touchmove', root._mpSecondaryEnable);
      }
      if (root._mpSecondaryKey) root.removeEventListener('keydown', root._mpSecondaryKey);
      if (root._mpHeroMedia && root._mpHeroSync) root._mpHeroMedia.removeEventListener('change', root._mpHeroSync);
      if (root._mpCatalogIdleId != null && 'cancelIdleCallback' in window) window.cancelIdleCallback(root._mpCatalogIdleId);
      if (root._mpCatalogTimerId != null) window.clearTimeout(root._mpCatalogTimerId);
      root._mpCatalogAbortControllers?.forEach((controller) => controller.abort());
      root._mpStorageShortfinder = null;
      root._mpTaxNoteObserver = null;
      root._mpSecondaryMediaObserver = null;
      root._mpSecondaryScrollScan = null;
      root._mpSecondaryIntent = null;
      root._mpSecondaryEnable = null;
      root._mpSecondaryKey = null;
      root._mpHeroMedia = null;
      root._mpHeroSync = null;
      root._mpCatalogAbortControllers = null;
    };
    document.querySelectorAll('[data-mp-universal-collection]').forEach(init);
    document.addEventListener('shopify:section:load',(event) => event.target.querySelectorAll('[data-mp-universal-collection]').forEach(init));
    document.addEventListener('shopify:section:unload',(event) => event.target.querySelectorAll('[data-mp-universal-collection]').forEach(cleanup));
  })();

